import { Howl } from 'howler';
import './typedef';

export const CURRENCY_SYMBOLS = {
	IDR: 'Rp', // Indonesian Rupiah
	USD: '$', // US Dollar
	EUR: '€', // Euro
	CRC: '₡', // Costa Rican Colón
	GBP: '£', // British Pound Sterling
	ILS: '₪', // Israeli New Sheqel
	INR: '₹', // Indian Rupee
	JPY: '¥', // Japanese Yen
	CNY: '¥', // Chinese Yuan
	KRW: '₩', // South Korean Won
	NGN: '₦', // Nigerian Naira
	PHP: '₱', // Philippine Peso
	PLN: 'zł', // Polish Zloty
	PYG: '₲', // Paraguayan Guarani
	THB: '฿', // Thai Baht
	UAH: '₴', // Ukrainian Hryvnia
	VND: '₫', // Vietnamese Dong
};

// Notification Types
export const NOTIFICATION_TYPES = {
	ORDER_NEW: 'new_order',
	NEW_WHOLESALE_ORDER: 'new_wholesale_order',
	PAYMENT_NEW: 'new_payment',
	FB_TOKEN_EXPIRED: 'fb_token_expired',
	ORDER_LIMIT: 'order_limit',
	ORDER_PROCESSED: 'order_processed',
	PAYMENT_CONFIRMATION: 'new_payment_confirmation',
	CONTACT_REMINDER: 'contact_reminder',
	BILLING_NEW: 'new_billing',
	WALLET_HISTORY_NEW: 'new_wallet_history',
	WALLET_HISTORY_UPDATE: 'wallet_history_update',
	WITHDRAWAL_NEW: 'new_withdrawal',
	EMPTY: 'empty',
	BILLING_PAYMENT: 'billing_payment',
	NEW_LOGISTIC: 'new_logistic',
	LOGISTIC_UPDATE: 'logistic_update',
	LOGISTIC: 'logistic',
	PRODUCT_SUSPENDED: 'product_suspended',
	PRODUCT_REQUESTED: 'product_requested',
	PRODUCT_PRICING: 'product_pricing',
	PRODUCT_UPDATED: 'product_updated',
	PRODUCT_IMPORTED: 'product_imported',
	PRODUCT_INVITATION: 'product_invitation',
	PRODUCT_INVITATION_DISTRIBUTOR: 'product_invitation_distributor',
	PRODUCT_STOCK: 'product_stock',
	PRODUCT_STATUS: 'product_status',
	WHATSAPP_FAILED: 'whatsapp_failed',
	NEW_DROPSHIPPER: 'new_dropshipper',
	NEW_SUPPLIER: 'new_supplier',
	WHOLESALE_DELIVERED: 'wholesale_mark_as_delivered',
	WHOLESALE_DELIVERY: 'wholesale_mark_as_delivery',
	WHOLESALE_PROCESS: 'wholesale_process',
};

export const NOTIFICATION_TYPES_CLASS = {
	new_order: 'order',
	new_wholesale_order: 'order-wholesale',
	new_payment: 'payment',
	fb_token_expired: 'facebook',
	order_limit: 'limit',
	new_payment_confirmation: 'payment-confirmation',
	order_processed: 'order-processed',
	empty: 'empty',
	contact_reminder: 'contact-reminder',
	new_billing: 'new-billing',
	new_wallet_history: 'new-wallet-history',
	wallet_history_update: 'new-wallet-history',
	new_withdrawal: 'payment-confirmation',
	billing_payment: 'payment-confirmation',
	new_logistic: 'new-billing',
	logistic_update: 'order-processed',
	whatsapp_failed: 'failed',
	product_requested: 'requested',
	product_pricing: 'pricing',
	product_updated: 'updated',
	product_imported: 'imported',
	product_invitation: 'invitation',
	product_invitation_distributor: 'invitation',
	product_stock: 'stock',
	new_dropshipper: 'dropshipper',
	new_supplier: 'supplier',
	product_status: 'product-status',
	wholesale_mark_as_delivery: 'new-billing',
	wholesale_process: 'new-billing',
};

// Notification Titles
export const NOTIFICATION_TITLES = {
	new_order: 'Pesanan Baru',
	new_payment: 'Pembayaran',
	fb_token_expired: 'Integrasi Facebook',
	order_limit: 'Order Limit',
	order_processed: 'Pesanan Telah Diproses',
	new_payment_confirmation: 'Konfirmasi Pembayaran',
	contact_reminder: 'Pengingat Kontak',
	empty: 'Notifikasi',
	new_logistic: 'Status Pengiriman',
};

export const defaultDistributorObject = {
	enabled: false,
	price: 0,
	slash_price: 0,
	stock: {
		enabled: true,
		quantity: 0,
		backorder: 1,
		visible: true,
	},
	wholesale: [],
	visibility: 'public',
	assigned_user: [],
};

// Agreements
export const AGREEMENTS_VERSION = {
	LOGISTIC: '1.0',
	INVENTRO: '1.0',
};

// Claim Types
export const CLAIM_TYPE = {
	LOST: 'lost',
	BROKEN: 'broken',
	UNCOVERED: 'uncovered',
	OVER_SLA: 'over_sla',
	FREE_SHIPPING: 'free_shipping',
};

// Claim Status
export const CLAIM_STATUS = {
	PENDING: 'pending',
	PROCESSING: 'processing',
	COMPLETED: 'completed',
};

export const FILTER_TAGS = [
	{
		type: 'dangerous_goods',
		label: 'Dangerous Goods',
	},
];

export const INSTANT_PAYMENT_FEE = 4000;

export const INSTANT_PAYMENT_FEE_TAX = 440;

export const fragileImage =
	'data:image/png;base64,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';

export const orderOnlineLogo = 'https://cdn.ostock.id/img/ostock-by-oo.png';

export const orderOnlineImage =
	'data:image/png;base64,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';

export const defaultProductImage =
	'https://cdn.orderonline.id/img/default-product.png';

export const reservedSubdomains = [
	// 'admin',
	'affiliate',
	'api',
	'api-dev',
	'api-staging',
	'app',
	'app2',
	'apps',
	'appstore',
	'assets',
	'blog',
	'cdn',
	'cdn2',
	'cdn-page',
	'community',
	'cron',
	'courier',
	'couriers',
	'dev',
	'developers',
	'email',
	'ftp',
	'funnel',
	'funnel-api',
	'group',
	'groups',
	'help',
	'images',
	'logistic',
	'logistics',
	'mail',
	'marketing',
	'marketplace',
	'monitor',
	'partner',
	'partners',
	'payments',
	'public',
	'reconcile',
	'send',
	'server',
	'shipment',
	'smtp',
	'socket',
	'staging',
	'staging-assets',
	'status',
	'status',
	'submit',
	'suppliers',
	'support',
	'trck',
	'ticket',
	'ticket-staging',
	'university',
	'wallet',
	'www',
];

export const reservedSlugs = [
	'payment',
	'payments',
	'payment-confirmation',
	'payment-success',
	'products',
	'categories',
	'cart',
	'checkout',
	'thanks',
	'thank-you',
	'blog',
	'my-account',
	'register',
	'login',
	'logout',
	'forgot-password',
	'wishlist',
	'sale',
	'orders',
	'about',
	'contact',
	'search',
	'settings',
	'storefront',
	'password',
	'page',
	'page-ssr',
	'page-staging',
	'pages',
	'published',
	'funnel',
	'funnels',
	'resellers',
	'reseller-area',
];

export const createProductTemplate = {
	bump: {
		status: false,
		name: 'Produk Tambahan',
		price: 0,
		url: '',
		data: {
			checkbox_label: 'Centang untuk membeli',
			title: 'Penawaran cuma untuk hari ini saja!',
			description: 'Beli sekranag, stok terbatas...',
		},
	},
	submit_action: {
		type: 'success_page',
		data: {
			url: '',
			wa_numbers: [],
			headline: 'Pembelian Berhasil',
			video: {
				url: '',
				autoplay: false,
			},
			body_text: 'Terima kasih sudah membeli produk ini...',
			purchase_link_enabled: true,
			purchase_url: '',
			purchase_label: '',
			bump_link_enabled: false,
			bump_url: '',
			bump_label: '',
		},
	},
	tracking: {
		form: {
			pixel: {
				ids: [],
				events: [
					{
						name: 'ViewContent',
					},
				],
			},
			gtm: {
				ids: [],
			},
		},
		success: {
			pixel: {
				ids: [],
				events: [
					{
						name: 'Purchase',
						value: 0,
						currency: 'IDR',
					},
				],
			},
			gtm: {
				ids: [],
			},
		},
	},
	style: {
		template: '1_step_left',
		background: 'grey',
	},
	elements: {
		header: {
			image: '',
			tagline: {
				enabled: false,
				text: '',
			},
		},
		guarantee_seals: 'satisfaction',
		fields: [
			{
				type: 'text',
				label: 'Nama',
				placeholder: 'Isikan nama anda...',
				name: 'name',
				required: true,
			},
			{
				type: 'text',
				label: 'No Handphone/Whatsapp',
				placeholder: 'Isikan no Whatsapp anda...',
				name: 'phone',
				required: true,
			},
			{
				type: 'text',
				label: 'Alamat Lengkap',
				placeholder: 'Isikan alamat lengkap anda...',
				name: 'address',
				required: true,
			},
			{
				type: 'select',
				label: 'Provinsi',
				placeholder: 'Pilih provinsi',
				name: 'state',
				required: true,
			},
			{
				type: 'select',
				label: 'Kota/Kabupaten',
				placeholder: 'Pilih kota/kabupaten',
				name: 'city',
				required: true,
			},
			{
				type: 'select',
				label: 'Kecamatan',
				placeholder: 'Pilih kecamatan',
				name: 'district',
				required: true,
			},
		],
		buy_button: {
			text: 'Pesan Sekarang',
			background: 'green',
		},
		video: {
			url: '',
		},
		image: {
			enabled: true,
		},
		coupon: {
			enabled: false,
		},
		features: [],
		testimonials: [],
		footer: {
			orderonline_logo: true,
			links_enabled: false,
			links: [],
		},
	},
	notification: {
		email: {
			status: true,
			value: '',
		},
	},
};

export const followUps = [
	{
		key: 'welcome',
		label: 'Welcome',
		description: '',
	},
	{
		key: 'order_detail',
		label: 'Order Detail',
		description: '',
	},
	{
		key: 'follow_up_1',
		label: 'Follow Up 1',
		description: '',
	},
	{
		key: 'follow_up_2',
		label: 'Follow Up 2',
		description: '',
	},
	{
		key: 'follow_up_3',
		label: 'Follow Up 3',
		description: '',
	},
	{
		key: 'follow_up_4',
		label: 'Follow Up 4',
		description: '',
	},
	{
		key: 'processing',
		label: 'Processing',
		description: '',
	},
	{
		key: 'closing',
		label: 'Completed',
		description: '',
	},
	{
		key: 'up_selling',
		label: 'Up Selling',
		description: '',
	},
	{
		key: 'order_confirmation_redirect',
		label: 'Redirect',
		description:
			'Jika anda membuat Success Page dengan tipe "Redirect to Whatsapp", customer akan mengirimkan text dibawah ini setelah mereka melakukan pemesanan!',
	},
];

export const defaultFollowUpMessage = [
	{
		key: 'follow-up-1',
		message: 'Welcome : Terima kasih telah register di INVENTRO, Pendaftaran anda akan diverifikasi oleh tim kurasi Ostock.',
	},
	{
		key: 'follow-up-2',
		message: 'Pendaftaran anda telah berhasil diverifikasi, untuk memulai silahkan liat akses halaman tutorial, open ticket atau CS LIVE kami.',
	},
];

export const defaultWelcomingMessage = {
	supplier: 'Hai Suppliers! Terima kasih dan Selamat bergabung di OStock.id! OStock yakin bahwa Kamu adalah salah satu supplier yang piawai dalam mengatur ketersediaan produk. Bersiaplah untuk serangkaian keseruan berjualan dengan produk terbaikmu hanya di OStock!\nUntuk informasi lebih lanjut silahkan menghubungi kami disini.\n\nNote : Pesan ini merupakan pesan otomatis, sesaat lagi kami akan segera menghubungimu\n\nTerima kasih, Stay Safe & Stay Healthy!',
	dropshipper: 'Selamat Datang! Verifikasi datamu sudah berhasil. Salam hangat dari OStock.id , dimana Berjualan Online jadi Lebih Mudah dengan Tanpa Modal! Untuk informasi lebih lanjut, silahkan menghubungi kami disini.\n\nNote : Pesan ini merupakan pesan otomatis, sesaat lagi kami akan segera menghubungimu\n\nTerima kasih, Have a nice day!',
};

export const defaultWhatsappAPI = {
	api_key: '',
	base_url: '',
	number_key: '',
	devices: [
		{
			number_key: 'csfNxUYxndni2wsE',
			key: 'supplier',
			label: 'Nomor Untuk Supplier',
			phone_number: '6285814847075',
		},
		{
			number_key: 'DyurssTZqQw35XLP',
			label: 'Nomor Untuk Seller',
			key: 'dropshipper',
			phone_number: '6281222001553',
		},
		{
			number_key: 'BzktUsAqCipWVB5X',
			label: 'Nomor OTP',
			key: 'phone_otp',
			phone_number: '6289656277348',
		},
	],
};

export const followUpTokens = [
	{ key: 'order_id', value: '{{order_id}}', label: 'Order ID' },
	{ key: 'order_date', value: '{{order_date}}', label: 'Order Date' },
	{ key: 'bank_accounts', value: '{{bank_accounts}}', label: 'Bank Accounts' },
	{
		key: 'bump_name_price',
		value: '{{bump_name_price}}',
		label: 'Bump Name + Price',
	},
	{ key: 'bump_name', value: '{{bump_name}}', label: 'Bump Name' },
	{ key: 'bump_price', value: '{{bump_price}}', label: 'Bump Price' },
	{ key: 'email', value: '{{email}}', label: 'Customer Email' },
	{ key: 'name', value: '{{name}}', label: 'Customer Name' },
	{ key: 'phone', value: '{{phone}}', label: 'Customer Phone' },
	{ key: 'address', value: '{{address}}', label: 'Customer Address' },
	{ key: 'province', value: '{{province}}', label: 'Customer Province' },
	{ key: 'city', value: '{{city}}', label: 'Customer City' },
	{ key: 'district', value: '{{district}}', label: 'Customer District' },
	{ key: 'zip', value: '{{zip}}', label: 'Customer ZIP' },
	{ key: 'notes', value: '{{notes}}', label: 'Notes' },
	{ key: 'product_name', value: '{{product_name}}', label: 'Product Name' },
	{ key: 'product_price', value: '{{product_price}}', label: 'Product Price' },
	// { key: 'product_sale_price', value: '{{product_sale_price}}', label: 'Product Sale Price' },
	{ key: 'quantity', value: '{{quantity}}', label: 'Quantity' },
	{ key: 'custom_fields', value: '{{custom_fields}}', label: 'Custom Fields' },
	{ key: 'shipping_cost', value: '{{shipping_cost}}', label: 'Shipping Cost' },
	{
		key: 'shipping_cod_cost',
		value: '{{shipping_cod_cost}}',
		label: 'COD Cost',
	},
	{
		key: 'shipping_cost_cod_cost',
		value: '{{shipping_cost_cod_cost}}',
		label: 'Shipping + COD Cost',
	},
	{
		key: 'shipping_courier',
		value: '{{shipping_courier}}',
		label: 'Shipping Courier',
	},
	{
		key: 'shipping_service',
		value: '{{shipping_service}}',
		label: 'Shipping Service',
	},
	{
		key: 'receipt_number',
		value: '{{receipt_number}}',
		label: 'Shipping Receipt Number',
	},
	{ key: 'total_price', value: '{{total_price}}', label: 'Total Price' },
	{
		key: 'coupon_discount',
		value: '{{coupon_discount}}',
		label: 'Coupon Discount',
	},
	{ key: 'coupon_code', value: '{{coupon_code}}', label: 'Coupon Code' },
	{ key: 'unique_code', value: '{{unique_code}}', label: 'Unique Code' },
	{ key: 'variation', value: '{{variation}}', label: 'Variation' },
	{
		key: 'payment_link',
		value: '{{payment_link}}',
		label: 'Payment Confirmation',
	},
	{
		key: 'payment_method',
		value: '{{payment_method}}',
		label: 'Payment Method',
	},
	{
		key: 'e_payment_link',
		value: '{{e_payment_link}}',
		label: 'E-Payment Link',
	},
	{
		key: 'order_details_link',
		value: '{{order_details_link}}',
		label: 'Order Details Link',
	},
	{ key: 'cs_name', value: '{{cs_name}}', label: 'Customer Service Name' },
	{ key: 'cs_phone', value: '{{cs_phone}}', label: 'Customer Service Phone' },
	{ key: 'cs_email', value: '{{cs_email}}', label: 'Customer Service Email' },
	{ key: 'cart_items', value: '{{cart_items}}', label: 'Cart Items' },
	{
		key: 'dropshipper_name',
		value: '{{dropshipper_name}}',
		label: 'Seller Name',
	},
	{
		key: 'dropshipper_phone',
		value: '{{dropshipper_phone}}',
		label: 'Seller Phone',
	},
];

export const previewTokens = [
	{ key: 'bank_accounts', value: '{{bank_accounts}}', label: 'Bank Accounts' },
	{ key: 'product_name', value: '{{product_name}}', label: 'Product Name' },
	{ key: 'product_price', value: '{{product_price}}', label: 'Product Price' },
	{ key: 'total_price', value: '{{total_price}}', label: 'Total Price' },
	{
		key: 'payment_link',
		value: '{{payment_link}}',
		label: 'Payment Confirmation',
	},
];

export const contactTypes = [
	{
		key: 'pending',
		label: 'Pending Order',
		description: '',
	},
	{
		key: 'processing',
		label: 'Processing',
		description: '',
	},
	{
		key: 'completed',
		label: 'Completed',
		description: '',
	},
];

export const contactTokens = [
	{ key: 'name', value: '{{name}}', label: 'Customer Name' },
	{ key: 'phone', value: '{{phone}}', label: 'Customer Phone' },
	{ key: 'address', value: '{{address}}', label: 'Customer Address' },
	{ key: 'city', value: '{{city}}', label: 'Customer City' },
	{ key: 'district', value: '{{district}}', label: 'Customer District' },
	{ key: 'product_name', value: '{{product_name}}', label: 'Product Name' },
	{ key: 'product_price', value: '{{product_price}}', label: 'Product Price' },
	{ key: 'shipping_cost', value: '{{shipping_cost}}', label: 'Shipping Cost' },
	{ key: 'total_price', value: '{{total_price}}', label: 'Total Price' },
	{ key: 'bank_account', value: '{{bank_account}}', label: 'Bank Account' },
	{ key: 'product_code', value: '{{product_code}}', label: 'Product Code' },
	{ key: 'date', value: '{{date}}', label: 'Date' },
];

export const autoresponderTypes = [
	{
		key: 'pending',
		label: 'Pending Order',
		description: 'When a customer orders this product, add them to:',
	},
	{
		key: 'processing',
		label: 'Processing',
		description: "When a customer's order is processed, add them to:",
	},
	{
		key: 'completed',
		label: 'Completed',
		description: "When a customer's order is completed, add them to:",
	},
];

export const caTypes = [
	{
		key: 'pending',
		label: 'Pending Order',
		description: 'When a customer orders this product, add them to:',
	},
	{
		key: 'processing',
		label: 'Processing',
		description: "When a customer's order is processed, add them to:",
	},
	{
		key: 'completed',
		label: 'Completed',
		description: "When a customer's order is completed, add them to:",
	},
];

export const oldBanks = [
	{
		name: 'bca',
		label: 'BCA',
	},
	{
		name: 'bca-syariah',
		label: 'BCA Syariah',
	},
	{
		name: 'bni',
		label: 'BNI',
	},
	{
		name: 'bni-syariah',
		label: 'BNI Syariah',
	},
	{
		name: 'bri',
		label: 'BRI',
	},
	{
		name: 'bri-syariah',
		label: 'BRI Syariah',
	},
	{
		name: 'cimb-niaga',
		label: 'CIMB Niaga',
	},
	{
		name: 'danamon',
		label: 'Danamon',
	},
	{
		name: 'mandiri',
		label: 'Mandiri',
	},
	{
		name: 'mandiri-syariah',
		label: 'Mandiri Syariah',
	},
	{
		name: 'muamalat',
		label: 'Muamalat',
	},
	{
		name: 'panin',
		label: 'Panin',
	},
	{
		name: 'btpn',
		label: 'BTPN',
	},
	{
		name: 'permata',
		label: 'Permata',
	},
	{
		name: 'bsi',
		label: 'Bank Syariah Indonesia (BSI)',
	},
	{
		name: 'mayapada',
		label: 'Bank Mayapada',
	},
];

export const banks = [
	{
		name: 'bca',
		label: 'PT. BCA (BANK CENTRAL ASIA) TBK',
		code: '0140397',
		icon: true,
	},
	{
		name: 'bni',
		label: 'PT. BANK NEGARA INDONESIA (BNI) (PERSERO)',
		code: '0090010',
		icon: true,
	},
	{
		name: 'bri',
		label: 'PT. BANK RAKYAT INDONESIA (BRI) (PERSERO)',
		code: '0020307',
		icon: true,
	},
	{
		name: 'cimb-niaga',
		label: 'PT. BANK CIMB NIAGA TBK',
		code: '0220026',
		icon: true,
	},
	{
		name: 'citibank',
		label: 'CITIBANK NA',
		code: '0310305',
		icon: true,
	},
	{
		name: 'danamon',
		label: 'PT. BANK DANAMON INDONESIA TBK',
		code: '0110042',
		icon: true,
	},
	{
		name: 'mandiri',
		label: 'PT. BANK MANDIRI',
		code: '',
		icon: true,
	},
	{
		name: 'anz-indonesia',
		label: 'ANZ INDONESIA',
		code: '0610306',
		icon: true,
	},
	{
		name: 'bangkok',
		label: 'BANGKOK BANK PUBLIC CO. LTD',
		code: '0400309',
		icon: false,
	},
	{
		name: 'aceh',
		label: 'BANK ACEH',
		code: '1169924',
		icon: false,
	},
	{
		name: 'aceh-syariah',
		label: 'BANK ACEH SYARIAH',
		code: '1169900',
		icon: false,
	},
	{
		name: 'bjb-syariah',
		label: 'BANK JABAR BANTEN SYARIAH',
		code: '4250018',
		icon: false,
	},
	{
		name: 'jatim-syariah',
		label: 'BANK JATIM UNIT USAHA SYARIAH',
		code: '1149928',
		icon: false,
	},
	{
		name: 'mnc',
		label: 'BANK MNC INTERNASIONAL',
		code: '4850010',
		icon: false,
	},
	{
		name: 'boa',
		label: 'BANK OF AMERICA NA',
		code: '0330301',
		icon: false,
	},
	{
		name: 'boc',
		label: 'BANK OF CHINA LIMITED',
		code: '0690300',
		icon: false,
	},
	{
		name: 'shinhan',
		label: 'BANK SHINHAN INDONESIA',
		code: '1520013',
		icon: false,
	},
	{
		name: 'bpd-jatim',
		label: 'BPD JATIM',
		code: '1140011',
		icon: false,
	},
	{
		name: 'bpd-kalsel',
		label: 'BPD KALIMANTAN SELATAN',
		code: '1220012',
		icon: false,
	},
	{
		name: 'kalsel-syariah',
		label: 'BPD KALIMANTAN SELATAN SYARIAH',
		code: '1229929',
		icon: false,
	},
	{
		name: 'bpd-kaltim-uus',
		label: 'BPD KALTIM UUS',
		code: '1249925',
		icon: false,
	},
	{
		name: 'bpd-lampung',
		label: 'BPD LAMPUNG',
		code: '1210051',
		icon: false,
	},
	{
		name: 'bpd-ntt',
		label: 'BPD NUSA TENGGARA TIMUR',
		code: '1300013',
		icon: false,
	},
	{
		name: 'bpd-sumbar',
		label: 'BPD SUMATERA BARAT (BANK NAGARI)',
		code: '1180013',
		icon: false,
	},
	{
		name: 'sumbar-syariah',
		label: 'BPD SUMATERA BARAT (NAGARI) SYARIAH',
		code: '1189920',
		icon: false,
	},
	{
		name: 'sumsel-dan-babel',
		label: 'BPD SUMSEL DAN BABEL',
		code: '1200016',
		icon: false,
	},
	{
		name: 'bpd-diy',
		label: 'BPD YOGYAKARTA',
		code: '1120015',
		icon: false,
	},
	{
		name: 'dgz',
		label: 'DEUTSCHE BANK AG',
		code: '0670304',
		icon: false,
	},
	{
		name: 'hsbc',
		label: 'HSBC INDONESIA',
		code: '0410302',
		icon: true,
	},
	{
		name: 'hsbc-syariah',
		label: 'HSBC UNIT USAHA SYARIAH',
		code: '0419921',
		icon: false,
	},
	{
		name: 'eximbank',
		label: 'INDONESIA EXIMBANK',
		code: '0030012',
		icon: false,
	},
	{
		name: 'chase',
		label: 'JPMORGAN CHASE BANK NA',
		code: '0320308',
		icon: false,
	},
	{
		name: 'hana',
		label: 'KEB HANA BANK INDONESIA',
		code: '4840017',
		icon: false,
	},
	{
		name: 'maybank-syariah',
		label: 'MAYBANK INDONESIA UNIT SYARIAH',
		code: '0169925',
		icon: false,
	},
	{
		name: 'agroniaga',
		label: 'PT. AGRONIAGA BANK',
		code: '4940014',
		icon: false,
	},
	{
		name: 'aib',
		label: 'PT.ANGLOMAS INTERNATIONAL BANK',
		code: '5310012',
		icon: false,
	},
	{
		name: 'artajasa',
		label: 'PT. ARTAJASA PEMBAYARAN ELEKTRONIK',
		code: 'ATJSIDJ2',
		icon: false,
	},
	{
		name: 'agris',
		label: 'PT. BANK AGRIS',
		code: '9450305',
		icon: false,
	},
	{
		name: 'andara',
		label: 'PT. BANK ANDARA',
		code: '4660019',
		icon: false,
	},
	{
		name: 'bad',
		label: 'PT. BANK ANTAR DAERAH',
		code: '0880013',
		icon: false,
	},
	{
		name: 'artha-graha',
		label: 'PT. BANK ARTHA GRAHA INT TBK',
		code: '0370028',
		icon: false,
	},
	{
		name: 'bca-syariah',
		label: 'PT. BANK BCA SYARIAH',
		code: '5360017',
		icon: true,
	},
	{
		name: 'bisnis',
		label: 'PT. BANK BISNIS INTERNATIONAL',
		code: '4590011',
		icon: false,
	},
	{
		name: 'bba',
		label: 'PT. BANK BUMI ARTA',
		code: '0760010',
		icon: false,
	},
	{
		name: 'capital',
		label: 'PT. BANK CAPITAL INDONESIA',
		code: '0540308',
		icon: false,
	},
	{
		name: 'chinatrust',
		label: 'PT. BANK CHINATRUST INDONESIA',
		code: '9490307',
		icon: false,
	},
	{
		name: 'cimb-syariah',
		label: 'PT. BANK CIMB NIAGA SYARIAH',
		code: '0229920',
		icon: false,
	},
	{
		name: 'commonwealth',
		label: 'PT. BANK COMMONWEALTH',
		code: '9500307',
		icon: false,
	},
	{
		name: 'danamon-syariah',
		label: 'PT. BANK DANAMON IND SYARIAH',
		code: '0119920',
		icon: false,
	},
	{
		name: 'dbs',
		label: 'PT. BANK DBS INDONESIA',
		code: '0460307',
		icon: false,
	},
	{
		name: 'blu',
		label: 'PT BANK DIGITAL BCA',
		code: '5010011',
		icon: false,
	},
	{
		name: 'dipo-int',
		label: 'PT. BANK DIPO INTERNATIONAL',
		code: '5230011',
		icon: false,
	},
	{
		name: 'dki',
		label: 'PT. BANK DKI',
		code: '1110012',
		icon: false,
	},
	{
		name: 'dki-syariah',
		label: 'PT. BANK DKI UNIT USAHA SYARIAH',
		code: '1119916',
		icon: false,
	},
	{
		name: 'ekonomi',
		label: 'PT. BANK EKONOMI RAHARJA',
		code: '0870010',
		icon: false,
	},
	{
		name: 'fama-int',
		label: 'PT. BANK FAMA INTERNATIONAL',
		code: '5620029',
		icon: false,
	},
	{
		name: 'ganesha',
		label: 'PT. BANK GANESHA',
		code: '1610017',
		icon: false,
	},
	{
		name: 'bhi',
		label: 'PT. BANK HARDA INTERNASIONAL',
		code: '5670011',
		icon: false,
	},
	{
		name: 'icbc',
		label: 'PT. BANK ICBC INDONESIA',
		code: '1640100',
		icon: false,
	},
	{
		name: 'ina',
		label: 'PT. BANK INA PERDANA',
		code: '5130014',
		icon: false,
	},
	{
		name: 'index',
		label: 'PT. BANK INDEX SELINDO',
		code: '5550018',
		icon: false,
	},
	{
		name: 'bjb',
		label: 'PT. BANK JABAR DAN BANTEN',
		code: '1100019',
		icon: true,
	},
	{
		name: 'jago',
		label: 'PT. Bank Jago Tbk',
		code: '5420012',
		icon: true,
	},
	{
		name: 'jago-syariah',
		label: 'PT. BANK JAGO TBK SYARIAH',
		code: '5429394',
		icon: false,
	},
	{
		name: 'bjj',
		label: 'PT. BANK JASA JAKARTA',
		code: '4720014',
		icon: false,
	},
	{
		name: 'kalbar-syariah',
		label: 'PT. BANK KALBAR SYARIAH',
		code: '1239922',
		icon: false,
	},
	{
		name: 'kesawan',
		label: 'PT. BANK KESAWAN',
		code: '1670015',
		icon: false,
	},
	{
		name: 'seabank',
		label: 'PT. BANK KESEJAHTERAAN EKONOMI (SeaBank)',
		code: '5350014',
		icon: false,
	},
	{
		name: 'liman',
		label: 'PT. BANK LIMAN INTERNATIONAL',
		code: '5260010',
		icon: false,
	},
	{
		name: 'maspion',
		label: 'PT. BANK MASPION INDONESIA',
		code: '1570018',
		icon: false,
	},
	{
		name: 'mayapada',
		label: 'PT. BANK MAYAPADA INTERNASIONAL T',
		code: '0970017',
		icon: true,
	},
	{
		name: 'maybank',
		label: 'PT BANK MAYBANK INDONESIA TBK',
		code: '0160131',
		icon: true,
	},
	{
		name: 'maybank-syariah',
		label: 'PT. BANK MAYBANK SYARIAH INDONESIA',
		code: '9470302',
		icon: false,
	},
	{
		name: 'mayora',
		label: 'PT. BANK MAYORA INDONESIA',
		code: '5530012',
		icon: false,
	},
	{
		name: 'mega',
		label: 'PT. BANK MEGA TBK',
		code: '4260121',
		icon: true,
	},
	{
		name: 'bmd',
		label: 'PT. BANK MESTIKA DHARMA',
		code: '1510010',
		icon: false,
	},
	{
		name: 'mitraniaga',
		label: 'PT. BANK MITRANIAGA',
		code: '4910015',
		icon: false,
	},
	{
		name: 'mizuho',
		label: 'PT. BANK MIZUHO INDONESIA',
		code: '0480303',
		icon: false,
	},
	{
		name: 'muamalat',
		label: 'PT. BANK MUAMALAT INDONESIA',
		code: '1470011',
		icon: true,
	},
	{
		name: 'mas',
		label: 'PT. BANK MULTIARTA SENTOSA',
		code: '5480010',
		icon: false,
	},
	{
		name: 'mutiara',
		label: 'PT. BANK MUTIARA TBK',
		code: '0950011',
		icon: false,
	},
	{
		name: 'nobu',
		label: 'PT. BANK NATIONALNOBU',
		code: '5030017',
		icon: false,
	},
	{
		name: 'neo',
		label: 'PT. BANK NEO COMMERCE TBK.',
		code: '4900012',
		icon: false,
	},
	{
		name: 'ntb-syariah',
		label: 'PT. BANK NTB UNIT USAHA SYARIAH',
		code: '1280010',
		icon: false,
	},
	{
		name: 'bnp',
		label: 'PT. BANK NUSANTARA PARAHYANGAN',
		code: '1450015',
		icon: false,
	},
	{
		name: 'ocbc-nisp',
		label: 'PT. BANK OCBC NISP TBK',
		code: '0280024',
		icon: true,
	},
	{
		name: 'ocbc',
		label: 'PT. BANK OCBC NISP TBK SYARIAH',
		code: '0289928',
		icon: false,
	},
	{
		name: 'panin',
		label: 'PT. BANK PAN INDONESIA TBK (PANIN)',
		code: '0190017',
		icon: true,
	},
	{
		name: 'panin-syariah',
		label: 'PT. BANK PANIN SYARIAH',
		code: '5170016',
		icon: false,
	},
	{
		name: 'bpd-jambi',
		label: 'PT. BANK PEMBANGUNAN DAERAH JAMBI',
		code: '1150014',
		icon: false,
	},
	{
		name: 'bpd-papua',
		label: 'PT. BANK PEMBANGUNAN DAERAH PAPUA',
		code: '1320019',
		icon: false,
	},
	{
		name: 'permata',
		label: 'PT. BANK PERMATA TBK',
		code: '0130475',
		icon: true,
	},
	{
		name: 'permata-syariah',
		label: 'PT. BANK PERMATA TBK SYARIAH',
		code: '0139926',
		icon: false,
	},
	{
		name: 'pundi',
		label: 'PT. BANK PUNDI INDONESIA',
		code: '5580017',
		icon: false,
	},
	{
		name: 'rabobank',
		label: 'PT. BANK RABOBANK INTERNATIONAL IND',
		code: '0890016',
		icon: false,
	},
	{
		name: 'brp',
		label: 'PT. BANK RESONA PERDANIA',
		code: '0470300',
		icon: false,
	},
	{
		name: 'sahabat',
		label: 'PT. BANK SAHABAT PURBA DANARTA',
		code: '5470017',
		icon: false,
	},
	{
		name: 'sampoerna',
		label: 'PT. BANK SAHABAT SAMPOERNA',
		code: '5230011',
		icon: false,
	},
	{
		name: 'sbi',
		label: 'PT. BANK SBI INDONESIA',
		code: '4980016',
		icon: false,
	},
	{
		name: 'shb',
		label: 'PT. BANK SINAR HARAPAN BALI',
		code: '5640012',
		icon: false,
	},
	{
		name: 'sinarmas',
		label: 'PT. BANK SINARMAS',
		code: '1530016',
		icon: false,
	},
	{
		name: 'sinarmas-syariah',
		label: 'PT. BANK SINARMAS SYARIAH',
		code: '1539923',
		icon: false,
	},
	{
		name: 'sulselbar',
		label: 'PT. BANK SULSELBAR',
		code: '1260027',
		icon: false,
	},
	{
		name: 'ssb-syariah',
		label: 'PT. BANK SULSELBAR SYARIAH',
		code: '1269947',
		icon: false,
	},
	{
		name: 'sulut',
		label: 'PT. BANK SULUT',
		code: '1270017',
		icon: false,
	},
	{
		name: 'smbci',
		label: 'PT. BANK SUMITOMO MITSUI INDONESIA',
		code: '0450304',
		icon: false,
	},
	{
		name: 'bpd-sumut',
		label: 'PT. BANK SUMUT (BPD SUMUT)',
		code: '1170010',
		icon: false,
	},
	{
		name: 'swadesi',
		label: 'PT. BANK SWADESI TBK',
		code: '1460047',
		icon: false,
	},
	{
		name: 'syariah-bukopin',
		label: 'PT. BANK SYARIAH BUKOPIN',
		code: '5210031',
		icon: false,
	},
	{
		name: 'bsi',
		label: 'PT. BANK SYARIAH INDONESIA',
		code: '4510017',
		icon: true,
	},
	{
		name: 'bsm',
		label: 'PT. BANK SYARIAH INDONESIA',
		code: '4510017',
		icon: false,
	},
	{
		name: 'bsmi',
		label: 'PT. BANK SYARIAH MEGA INDONESIA',
		code: '5060016',
		icon: false,
	},
	{
		name: 'btn',
		label: 'PT. BANK TABUNGAN NEGARA (BTN) (PERSERO)',
		code: '2000150',
		icon: true,
	},
	{
		name: 'btpn',
		label: 'PT. BANK TABUNGAN PENSIUNAN NASIONAL',
		code: '2130101',
		icon: true,
	},
	{
		name: 'btpn-syariah',
		label: 'PT. BANK TABUNGAN PENSIUNAN NASIONAL (BTPN) SYARIAH',
		code: '2130101',
		icon: false,
	},
	{
		name: 'uob-indonesia',
		label: 'PT. BANK UOB INDONESIA',
		code: '0230016',
		icon: true,
	},
	{
		name: 'victoria',
		label: 'PT. BANK VICTORIA INTERNATIONAL',
		code: '5660018',
		icon: false,
	},
	{
		name: 'victoria-syariah',
		label: 'PT. BANK VICTORIA SYARIAH',
		code: '4050072',
		icon: false,
	},
	{
		name: 'windu',
		label: 'PT. BANK WINDU KENTJANA INTERNATIONAL TBK',
		code: '0360300',
		icon: false,
	},
	{
		name: 'bws',
		label: 'PT. BANK WOORI INDONESIA',
		code: '2120001',
		icon: false,
	},
	{
		name: 'saudara',
		label: 'PT. B. HIMPUNAN SAUDARA 1906 TBK',
		code: '2120001',
		icon: false,
	},
	{
		name: 'bii',
		label: 'PT. BII TBK. SYARIAH',
		code: '0169925',
		icon: false,
	},
	{
		name: 'paribas',
		label: 'PT. BNP PARIBAS INDONESIA',
		code: '0570307',
		icon: false,
	},
	{
		name: 'bpd-bali',
		label: 'PT. BPD BALI',
		code: '1290013',
		icon: false,
	},
	{
		name: 'bpd-bengkulu',
		label: 'PT. BPD BENGKULU',
		code: '1330012',
		icon: false,
	},
	{
		name: 'bpd-diy-syariah',
		label: 'PT. BPD DIY SYARIAH',
		code: '1129922',
		icon: false,
	},
	{
		name: 'bpd-jateng',
		label: 'PT. BPD JAWA TENGAH',
		code: '1130348',
		icon: false,
	},
	{
		name: 'jateng-syariah',
		label: 'PT. BPD JAWA TENGAH SYARIAH',
		code: '1139938',
		icon: false,
	},
	{
		name: 'bpd-kalbar',
		label: 'PT. BPD KALIMANTAN BARAT',
		code: '1230015',
		icon: false,
	},
	{
		name: 'bpd-kaltim',
		label: 'PT. BPD KALIMANTAN TIMUR',
		code: '1240018',
		icon: false,
	},
	{
		name: 'bpd-kalteng',
		label: 'PT. BPD KALTENG',
		code: '1250011',
		icon: false,
	},
	{
		name: 'bpd-maluku',
		label: 'PT. BPD MALUKU',
		code: '1310016',
		icon: false,
	},
	{
		name: 'bpd-ntb',
		label: 'PT. BPD NUSA TENGGARA BARAT',
		code: '1280010',
		icon: false,
	},
	{
		name: 'bpd-riau',
		label: 'PT. BPD RIAU',
		code: '1190016',
		icon: false,
	},
	{
		name: 'bpd-riau-syariah',
		label: 'PT. BPD RIAU UNIT USAHA SYARIAH',
		code: '1190016',
		icon: false,
	},
	{
		name: 'bpd-sulteng',
		label: 'PT.BPD SULAWESI TENGAH',
		code: '1340015',
		icon: false,
	},
	{
		name: 'bpd-sultra',
		label: 'PT. BPD SULAWESI TENGGARA',
		code: '1350018',
		icon: false,
	},
	{
		name: 'bpd-sb-syariah',
		label: 'PT. BPD SUMSEL DAN BABEL SYARIAH',
		code: '1209923',
		icon: false,
	},
	{
		name: 'sumut-syariah',
		label: 'PT. BPD SUMUT SYARIAH',
		code: '1179927',
		icon: false,
	},
	{
		name: 'btn-syariah',
		label: 'PT. BTN (PERSERO) SYARIAH',
		code: '2009928',
		icon: false,
	},
	{
		name: 'bukopin',
		label: 'PT. BUKOPIN',
		code: '4410010',
		icon: true,
	},
	{
		name: 'cnb',
		label: 'PT. CENTRATAMA NASIONAL BANK',
		code: '5590010',
		icon: false,
	},
	{
		name: 'ksei',
		label: 'PT. KUSTODIAN SENTRAL EFEK INDONESIA',
		code: 'KSEIIDJ1',
		icon: false,
	},
	{
		name: 'pmb',
		label: 'PT. PRIMA MASTER BANK',
		code: '5200012',
		icon: false,
	},
	{
		name: 'scb',
		label: 'STANDARD CHARTERED BANK',
		code: '0500306',
		icon: false,
	},
	{
		name: 'mitsubishi',
		label: 'THE BOT MITSUBISHI UFJ LTD',
		code: '0420305',
		icon: false,
	},
	{
		name: 'rbs',
		label: 'THE ROYAL BANK OF SCOTLAND N.V.',
		code: '0520302',
		icon: false,
	},
];

export const shippingCouriers = [
	{ key: 'oexpress', label: 'OExpress', force_enabled: true },
	{ key: 'sap', label: 'SAP Express Courier', force_enabled: false },
	// { key: 'sicepat', label: 'SiCepat Ekspress', force_enabled: false },
	{ key: 'jne', label: 'JNE Express', force_enabled: false },
	{ key: 'jnt', label: 'J&T Express', force_enabled: false },
	{ key: 'ninja', label: 'Ninja Xpress', force_enabled: false },
	// { key: 'pos', label: 'Pos Indonesia', force_enabled: false },
	// { key: 'tiki', label: 'TIKI Express', force_enabled: false },
	// { key: 'wahana', label: 'Wahana Express', force_enabled: false },
	// { key: 'rpx', label: 'RPX', force_enabled: false },
	// { key: 'lion', label: 'Lion Parcel', force_enabled: false },
	{ key: 'idexpress', label: 'ID Express', force_enabled: false },
	// { key: 'paxel', label: 'Paxel', force_enabled: false },
];

export const shippingServices = [
	{
		value: 'regular',
		label: 'Regular',
	},
	{
		value: 'next_day',
		label: 'Next Day',
	},
	{
		value: 'economical',
		label: 'Economical',
	},
	{
		value: 'same_day',
		label: 'Same Day',
		// info: 'Hanya tersedia di kurir SiCepat',
	},
	{
		value: 'truck',
		label: 'Cargo',
		info: 'Hanya tersedia di kurir JNE',
	},
	// {
	// 	value: 'instant',
	// 	label: 'Instant',
	// 	info: 'For Gosend',
	// },
];

export const defaultFields = [
	{
		name: 'name',
		field: 'input',
		type: 'text',
		label: 'Nama',
		placeholder: 'Nama Anda',
		required: true,
		enabled: true,
		mandatory: true,
	},
	{
		name: 'phone',
		field: 'input',
		type: 'text',
		label: 'No Handphone/WhatsApp',
		placeholder: 'No. WhatsApp Anda',
		required: true,
		enabled: true,
		mandatory: true,
	},
	{
		name: 'email',
		field: 'input',
		type: 'email',
		label: 'Email',
		placeholder: 'Email Anda',
		required: false,
		enabled: true,
	},
	{
		name: 'quantity',
		field: 'select',
		type: 'number',
		label: 'Jumlah Pesanan',
		placeholder: 'Jumlah Pesanan',
		required: false,
		enabled: false,
		value: {
			default: 1,
			min: 1,
			max: 99,
		},
	},
	{
		name: 'notes',
		field: 'input',
		type: 'text',
		label: 'Catatan',
		placeholder: 'Masukkan Catatan Pemesanan',
		required: false,
		enabled: false,
	},
	{
		name: 'address',
		field: 'input',
		type: 'text',
		label: 'Alamat Lengkap',
		placeholder: 'Alamat Lengkap Anda',
		required: true,
		enabled: true,
	},
	{
		name: 'province',
		field: 'select',
		type: 'text',
		label: 'Provinsi',
		placeholder: 'Pilih Provinsi',
		required: true,
		enabled: false,
	},
	{
		name: 'city',
		field: 'select',
		type: 'text',
		label: 'Kota/Kabupaten',
		placeholder: 'Pilih Kota/Kabupaten',
		required: true,
		enabled: false,
	},
	{
		name: 'district',
		field: 'select',
		type: 'text',
		label: 'Kecamatan',
		placeholder: 'Pilih Kecamatan',
		required: true,
		enabled: false,
	},
	{
		name: 'complete_district',
		field: 'select',
		type: 'text',
		label: 'Kota / Kecamatan',
		placeholder: 'Masukkan Kota / Kecamatan',
		required: true,
		enabled: true,
	},
];

export const defaultCustomField = {
	name: 'custom',
	field: 'input',
	type: 'text',
	label: 'Custom Field',
	placeholder: 'Custom Field',
	required: false,
	enabled: true,
	mandatory: false,
	options: ['Option 1'],
};

export const defaultCouponData = {
	id: '',
	name: '',
	code: '',
	status: {
		name: 'Enabled',
		value: '1',
	},
	type: {
		name: 'Fixed Price',
		value: 'fixed_price',
	},
	discount: 0,
	discountFor: {
		name: 'Product',
		value: 'product',
	},
	usageLimit: {
		name: 'Unlimited',
		value: '-1',
	},
	schedule: {
		enabled: false,
		since: '',
		until: '',
	},
	quantity_limit: {
		enabled: false,
		limit: 1,
	},
	maximum_discount: {
		enabled: false,
		amount: 0,
	},
	minimum_spend: {
		enabled: false,
		amount: 0,
	},
	payment_method: {
		enabled: false,
		methods: ['bank_transfer', 'cod'],
	},
	new_customer: {
		enabled: false,
	},
};

export const defaultPackages = [
	{
		name: 'personal',
		label: 'Personal',
	},
	{
		name: 'professional',
		label: 'Professional',
	},
	{
		name: 'enterprise',
		label: 'Enterprise',
	},
	{
		name: 'personal_2',
		label: 'Personal 2',
	},
	{
		name: 'business_2',
		label: 'Business 2',
	},
	{
		name: 'enterprise_2',
		label: 'Enterprise 2',
	},
];

export const defaultPackagesLength = [
	{ value: 1, label: '1 Month' },
	{ value: 2, label: '2 Months' },
	{ value: 3, label: '3 Months' },
	{ value: 4, label: '4 Months' },
	{ value: 5, label: '5 Months' },
	{ value: 6, label: '6 Months' },
	{ value: 7, label: '7 Months' },
	{ value: 8, label: '8 Months' },
	{ value: 9, label: '9 Months' },
	{ value: 10, label: '10 Months' },
	{ value: 11, label: '11 Months' },
	{ value: 12, label: '12 Months' },
	{ value: 60, label: '5 Years' },
];

export const defaultPaymentFields = [
	{
		name: 'order_id',
		field: 'input',
		type: 'text',
		label: 'Order ID',
		placeholder: 'No. Pesanan',
		required: true,
		enabled: true,
		mandatory: true,
	},
	{
		name: 'account_name',
		field: 'input',
		type: 'text',
		label: 'Atas Nama Rekening',
		placeholder: 'Pemilik Rekening',
		required: true,
		enabled: true,
	},
	{
		name: 'transfer_to',
		field: 'select',
		type: 'text',
		label: 'Transfer ke',
		placeholder: '',
		required: true,
		enabled: true,
	},
	{
		name: 'transfer_date',
		field: 'input',
		type: 'date',
		label: 'Tanggal Transfer',
		placeholder: 'Tanggal Transfer',
		required: true,
		enabled: true,
	},
	{
		name: 'transfer_amount',
		field: 'input',
		type: 'number',
		label: 'Jumlah Transfer',
		placeholder: 'Contoh => 10000',
		required: true,
		enabled: true,
		mandatory: true,
	},
	{
		name: 'transfer_receipt',
		field: 'input',
		type: 'file',
		label: 'Bukti Transfer',
		placeholder: '',
		required: false,
		enabled: true,
	},
];

export const statItems = [
	'users',
	'products',
	'submissions',
	// 'transaction',
	'gross_revenue',
	// 'net_revenue',
	// 'bump_revenue',
	'shipping_cost',
	// 'coupon_claimed',
	'commissions',
	'service_fee',
	'product_sourcing_fee',
	'brands',
	'directs',
	'product_requests',
	'handling_fee',
	'ask_stock',
	'ticket',
	'revenue_product',
];

export const defaultTestimonial = {
	image: 'https://ostock.id/images/people.png',
	name: '',
	text: '',
};

export const defaultAttributes = [
	{
		name: 'Ukuran',
		// values: ['S', 'M', 'L', 'XL'],
		// options: ['S', 'M', 'L', 'XL'],
		values: [],
		object_values: [],
	},
	{
		name: 'Warna',
		// options: ['Hitam', 'Putih', 'Biru', 'Merah'],
		values: [],
		object_values: [],
	},
];

export const defaultStock = {
	enabled: true,
	quantity: 0,
	backorder: 1,
	status: 1,
	visible: false,
	warehouse_enabled: false,
};

export const defaultUom = {
	type: 'pcs',
	value: 1,
};

export const defaultMargin = 50000;

export const defaultProduct = {
	name: '',
	slug: '',
	slugValid: true,
	price: 0,
	sale_price: {
		enabled: false,
		price: 0,
		schedule: {
			enabled: false,
			since: '',
			until: '',
		},
	},
	pages: [],
	status: 'request', // changed from live to request
	images: ['', '', '', '', '', '', '', '', '', ''],
	videos: [''],
	isUploading: false,
	imageEnabled: true,
	description: '',
	code: '',
	weight: 0,
	type: 'simple',
	variations: {
		attributes: [],
		prices: [],
		multiple_variations: {
			enabled: false,
		},
	},
	wholesale: [],
	category: {
		category: '',
		category_slug: '',
		sub_category: '',
		sub_category_slug: '',
		sub_sub_category: '',
		sub_sub_category_slug: '',
	},
	cogs: 0,
	stock: defaultStock,
	isPublic: false,
	dropship: {
		enabled: true,
		type: 'nominal',
		margin: defaultMargin,
		max_dropshipper: 100,
		current_dropshipper: 0,
		original_price: 0,
	},
	commission_percentage: 5,
	outsource_commission: {
		type: 'percentage',
		value: 5,
	},
	change_logs: [],
	uom: {
		type: 'pcs',
		value: 1,
	},
};

export const defaultMarketingKit = {
	link: '',
	description: '',
	visible: false,
};

// Default Category
export const defaultCategory = {
	category: '',
	category_slug: '',
	sub_category: '',
	sub_category_slug: '',
	sub_sub_category: '',
	sub_sub_category_slug: '',
};

// Form Settings
export const defaultFormSettings = {
	mode: 'all',
	initial_fields: 1,
	label: false,
};

// Default Form
export const defaultForm = {
	name: 'Checkout Page 1',
	language: 'id',
	settings: defaultFormSettings,
};

export const defaultBump = {
	enabled: false,
	name: '',
	price: 0,
	priceDisplay: '0',
	weight: 0,
	checkbox: 'Centang untuk memesan juga',
	title: 'Nama Produk Bump Anda + Harga',
	content: 'Penjelasan Tentang Produk Bump Anda Disini',
	image: '',
};

export const defaultBuyButton = {
	text: 'Beli Sekarang',
	color: 'orange',
};

// export const defaultSuccessInstantText = 'Pembayaran Anda senilai \n{{total_price}}\n telah kami terima \nKami akan memproses pesanan Anda';
export const defaultSuccessInstantText =
	'<h4>Selamat, pembayaranmu berhasil!</h4>\n Total Bayar \n{{total_price}}\n Pesanan Anda akan segera kami proses';

export const defaultSubmitAction = {
	type: { key: 'success_page', label: 'Show Success Page' },
	url: '',
	waNumbers: [''],
	header: {
		title: {
			enabled: false,
			text: '',
		},
	},
	headline: 'Terimakasih sudah melakukan order {{product_name}}',
	video: {
		url: '',
		autoplay: false,
	},
	bodyText:
		'Untuk menyelesaikan proses order, silahkan transfer sejumlah \n{{total_price}}\n ke salah satu bank berikut ini:\n\n{{bank_accounts}}\n\nKonfirmasikan pembayaran anda di: {{payment_link}}',
	bodyTextCod:
		'Orderan anda kini kami proses, silahkan tunggu kedatangan kurir dalam 2-4 hari kedepan dan siapkan pembayaran senilai\n{{total_price}}\nuntuk dibayarkan ke kurir langsung.',
	bodyTextInstant: defaultSuccessInstantText,
	purchaseLabel: "Klik disini untuk melihat 'Product Name'",
	bumpLabel: "Klik disini untuk melihat 'Bump Offer'",
};

export const defaultBulletPoints = ['Fitur Satu', 'Fitur Dua'];

export const defaultMultipleVariations = {
	enabled: false,
	quantity_type: 'each',
	select_type: 'radio',
	row_type: 'static',
	add_label: 'Tambah Variasi',
};

export const defaultUniqueCode = {
	enabled: false,
	type: 'decrease',
	min: 1,
	max: 999,
};

export const defaultUniqueCodeOstock = {
	enabled: true,
	type: 'decrease',
	min: 1,
	max: 999,
};

export const defaultShipping = {
	enabled: true,
	free: false,
	flat: false,
	flatPrice: 0,
	couriers: ['sap', 'oexpress'],
	services: ['regular'],
	origin: false,
	province: null,
	city: null,
	subdistrict: null,
	markup: 0,
	warehouse_id: null,
};

export const pixelEvents = [
	'AddPaymentInfo',
	'AddToCart',
	'AddToWishlist',
	'CompleteRegistration',
	'InitiateCheckout',
	'Lead',
	'Purchase',
	'Search',
	'ViewContent',
];

export const memberRoles = [
	{ label: 'Admin', value: 'owner_admin' },
	// { label: 'Customer Service', value: 'owner_cs' },
	{ label: 'Shipper', value: 'owner_shipper' },
];

// User Capabilites
export const capabilities = {
	all: [
		'dashboard_view',
		'product_add',
		'product_view',
		'product_edit',
		'product_delete',
		'order_view',
		'order_process',
		'order_shipping_label',
		'order_export',
		'statistic_submission_count',
		'statistic_shipping_pending',
		'statistic_shipping_processed',
		'statistic_shipping_delivery',
		'statistic_shipping_completed',
		// 'statistic_submission_count',
		// 'statistic_transaction_count',
		// 'statistic_paid_ratio',
		// 'statistic_net_revenue',
		// 'statistic_bump_count',
		// 'statistic_bump_revenue',
		// 'statistic_gross_revenue',
		// 'statistic_gross_profit',
		// 'statistic_net_profit',
		// 'statistic_coupon_discount_claimed',
		// 'statistic_shipping_cost',
		// 'statistic_unpaid_count',
		// 'statistic_cogs',
		// 'statistic_unpaid_revenue',
		'wallet_view',
		'wallet_withdraw',
		'inventory_view',
		'inventory_update_stock',
	],
	owner_admin: [
		'dashboard_view',
		'product_add',
		'product_view',
		'product_edit',
		'product_delete',
		'order_view',
		'order_process',
		'order_shipping_label',
		'order_export',
		'statistic_submission_count',
		'statistic_shipping_pending',
		'statistic_shipping_processed',
		'statistic_shipping_delivery',
		'statistic_shipping_completed',
		'wallet_view',
		'wallet_withdraw',
		'inventory_view',
		'inventory_update_stock',
	],
	owner_cs: [
		'dashboard_view',
		'product_add',
		'product_view',
		'product_edit',
		'product_delete',
		'order_view',
		'order_process',
		'order_shipping_label',
		'order_export',
		'statistic_submission_count',
		'statistic_shipping_pending',
		'statistic_shipping_processed',
		'statistic_shipping_delivery',
		'statistic_shipping_completed',
		'wallet_view',
		'wallet_withdraw',
		'inventory_view',
		'inventory_update_stock',
	],
	owner_shipper: [
		'dashboard_view',
		'order_view',
		'order_process',
		'order_shipping_label',
		'statistic_submission_count',
		'statistic_shipping_pending',
		'statistic_shipping_processed',
		'statistic_shipping_delivery',
		'statistic_shipping_completed',
		'inventory_view',
		// 'inventory_update_stock',
	],
};

// User Capabilities - Statistics
export const capabilitiesStats = [
	{
		key: 'statistic_submission_count',
		label: 'Total Orders',
	},
	{
		key: 'statistic_transaction_count',
		label: 'Total Paid',
	},
	{
		key: 'statistic_paid_ratio',
		label: 'Paid Ratio',
	},
	{
		key: 'statistic_unpaid_count',
		label: 'Unpaid Orders',
	},
	{
		key: 'statistic_cogs',
		label: 'COGS',
	},
	{
		key: 'statistic_unpaid_revenue',
		label: 'Unpaid Revenue',
	},
	{
		key: 'statistic_bump_count',
		label: 'Bump Orders',
	},
	{
		key: 'statistic_bump_revenue',
		label: 'Bump Revenue',
	},
	{
		key: 'statistic_coupon_discount_claimed',
		label: 'Discount Claim',
	},
	{
		key: 'statistic_shipping_cost',
		label: 'Shipping Cost',
	},
	{
		key: 'statistic_gross_revenue',
		label: 'Gross Revenue',
	},
	{
		key: 'statistic_handling_fee',
		label: 'Handling Fee',
	},
	{
		key: 'statistic_net_revenue',
		label: 'Net Revenue',
	},
	{
		key: 'statistic_gross_profit',
		label: 'Gross Profit',
	},
	// Net Profit
	{
		key: 'statistic_net_profit',
		label: 'Net Profit',
	},
	// Expense
	{
		key: 'statistic_expense',
		label: 'Expenses',
	},
	// Quantity Sold
	{
		key: 'statistic_quantity',
		label: 'Quantity Sold',
	},
];

export const memberRoles2 = [
	// { label: 'Customer Service', value: 'owner_cs' },
	{ label: 'Shipper', value: 'owner_shipper' },
	{ label: 'Admin', value: 'owner_admin' },
];

export const defaultMaxQtyConfig = {
	enabled: false,
	value: 3,
};

export const defaultOrderDistribution = { type: 'equal', team_members: [] };

export const defaultProductSourcingFeeConfig = {
	type: 'percentage',
	value: 5,
};

export const defaultProductColumns = [
	// { value: 'product', label: 'Product', category: 'product' },
	{ value: 'supplier', label: 'Supplier', category: 'product' },
	{ value: 'seller', label: 'Seller', category: 'product' },
	{ value: 'type', label: 'Type', category: 'product' },
	{ value: 'variations', label: 'Variations', category: 'product' },
	{ value: 'price', label: 'Price', category: 'product' },
	{ value: 'commision', label: 'Commision', category: 'product' },
	{ value: 'margin', label: 'Margin', category: 'product' },
	{ value: 'product_sourcing_fee', label: 'Product Sourcing Fee', category: 'product' },
	{ value: 'recommended_price', label: 'Recommended Price', category: 'product' },
	{ value: 'stock', label: 'Stock', category: 'product' },
	{ value: 'max_qty', label: 'Max Qty', category: 'product' },
	{ value: 'status', label: 'Status', category: 'product' },
	{ value: 'visibility', label: 'Visibility', category: 'others' },
	{ value: 'distributor_status', label: 'Wholesale Status', category: 'product' },
	{ value: 'distributor_price', label: 'Wholesale Base Price', category: 'product' },
	{ value: 'distributor_slash_price', label: 'Wholesale Slash Price', category: 'product' },
	{ value: 'distributor_wholesale_price', label: 'Wholesale Price', category: 'product' },
	{ value: 'distributor_stock', label: 'Wholesale Stock', category: 'product' },
	{ value: 'distributor_visibility', label: 'Wholesale Visibility', category: 'product' },
	{ value: 'blacklisted_sellers', label: 'Blacklisted Sellers', category: 'others' },
	{ value: 'changes', label: 'Changes', category: 'others' },
	{ value: 'change_history', label: 'Change History', category: 'others' },
	{ value: 'created_at', label: 'Created at', category: 'date' },
	{ value: 'timestamps', label: 'Timestamps', category: 'date' },
	{ value: 'action', label: 'Actions', category: 'others' },
];
export const defaultOrdersColumns = [
	{ value: 'id', label: 'Order ID', category: 'order' },
	{ value: 'customer_name', label: 'Customer Name', category: 'customer' },
	// { value: 'type', label: 'Order Type', category: 'order' },
	{ value: 'customer_email', label: 'Customer Email', category: 'customer' },
	{ value: 'city', label: 'City', category: 'customer' },
	{ value: 'product_name', label: 'Product Name', category: 'order' },
	{ value: 'product_code', label: 'Product SKU', category: 'order' },
	{ value: 'quantity', label: 'Quantity', category: 'order' },
	// { value: 'bump', label: 'Bump', category: 'order' },
	{ value: 'status', label: 'Status', category: 'order' },
	{ value: 'payment_status', label: 'Payment Status', category: 'order' },
	// { value: 'date', label: 'Date', category: 'order' },
	{ value: 'date_ordered', label: 'Ordered At', category: 'date', adminOnly: true },
	{ value: 'date_created', label: 'Created At', category: 'date' },
	{ value: 'date_processing', label: 'Processing At', category: 'date', adminOnly: true },
	{ value: 'date_manifested', label: 'Manifested At', category: 'date', adminOnly: true },
	{ value: 'date_delivered', label: 'Delivered At', category: 'date', adminOnly: true },
	{ value: 'date_returning', label: 'Returning At', category: 'date', adminOnly: true },
	{ value: 'shipping.returned_at', label: 'Returned At', category: 'date', adminOnly: true },
	{ value: 'date_return_completed', label: 'Return Completed At', category: 'date', adminOnly: true },
	{ value: 'date_cancelled', label: 'Cancelled At', category: 'date', adminOnly: true },
	{ value: 'date_refunded', label: 'Refunded At', category: 'date', adminOnly: true },
	// { value: 'coupon', label: 'Coupon', category: 'order' },
	// { value: 'gross_revenue', label: 'Gross Revenue', category: 'order' },
	// { value: 'cogs', label: 'COGS', category: 'order' },
	// { value: 'follow_up', label: 'Follow Up', category: 'others' },
	{ value: 'actions', label: 'Actions', category: 'others' },
	// { value: 'belongs_to', label: 'Handled By', category: 'order' },
	// { value: 'processing_at', label: 'Processing At', category: 'order' },
	// { value: 'completed_at', label: 'Completed At', category: 'order' },
	// { value: 'paid_at', label: 'Paid At', category: 'order' },
	{ value: 'payment_info', label: 'Payment Info', category: 'order' },
	// { value: 'custom_fields', label: 'Custom Fields', category: 'order' },
	{ value: 'receipt_number', label: 'Receipt Number', category: 'order' },
	// {
	// 	value: 'checkout_page_name',
	// 	label: 'Checkout Page Name',
	// 	category: 'order',
	// },
	{ value: 'variations', label: 'Variations', category: 'order' },
	// { value: 'meta_utm_source', label: 'UTM Source', category: 'tracking' },
	// { value: 'meta_utm_medium', label: 'UTM Medium', category: 'tracking' },
	// { value: 'meta_utm_campaign', label: 'UTM Campaign', category: 'tracking' },
	// { value: 'meta_utm_term', label: 'UTM Term', category: 'tracking' },
	// { value: 'meta_utm_content', label: 'UTM Content', category: 'tracking' },
	// { value: 'tags', label: 'Tags', category: 'others' },
	// { value: 'shipping_info', label: 'Shipping Info', category: 'order' },
	// { value: 'meta', label: 'Meta Data', category: 'order', info: 'IP Address' },
	// { value: 'dropshipper', label: 'Seller', category: 'order' },
	// { value: 'notes', label: 'Notes', category: 'order' },
	// { value: 'reseller', label: 'Reseller', category: 'order' },
	{ value: 'reference_id', label: 'Reference ID', category: 'order' },
	{ value: 'seller', label: 'Seller', category: 'order', adminOnly: true },
	{ value: 'supplier', label: 'Supplier', category: 'order', adminOnly: true },
	{ value: 'courier', label: 'Courier', category: 'order', adminOnly: true },
	{ value: 'net_revenue', label: 'Price', category: 'order', adminOnly: true },
	{ value: 'total_seller_price', label: 'Seller Price', category: 'order', adminOnly: true },
	{ value: 'shipping_cost', label: 'Shipping Cost', category: 'order', adminOnly: true },
	{ value: 'cod_fee', label: 'COD Fee', category: 'order', adminOnly: true },
	{ value: 'shipping_markup', label: 'Shipping Markup', category: 'order', adminOnly: true },
	{ value: 'unique_code', label: 'Unique Code', category: 'order', adminOnly: true },
	{ value: 'commission_fee', label: 'Commission Fee', category: 'order', adminOnly: true },
	{ value: 'product_sourcing_fee', label: 'Product Sourcing Fee', category: 'order', adminOnly: true },
	{ value: 'total_price', label: 'Total', category: 'order', adminOnly: true },
];


export const defaultSectionTitles = {
	contact: 'Data Penerima:',
	variations: 'Pilihan Produk:',
	payment: 'Metode Pembayaran:',
	features: 'Yang Anda Dapatkan:',
	shipping: 'Pengiriman:',
};

export const defaultWholesaleItem = { min: '', price: '' };

export const defaultStore = {
	name: '',
	logo: '',
	shipping: {
		origin: {
			province: {
				id: '6',
				name: 'DKI Jakarta',
			},
			city: {
				id: '152',
				name: 'Kota Jakarta Pusat',
			},
			subdistrict: {
				id: '',
				name: '',
			},
		},
		couriers: ['jne'],
	},
	social_media_accounts: {
		youtube: '',
		instagram: '',
		facebook: '',
	},
	location: {
		lat: '',
		lng: '',
	},
};

export const presetRangeLabel = {
	en: {
		lifetime: 'Lifetime',
		yesterday: 'Yesterday',
		today: 'Today',
		thisMonth: 'This Month',
		lastMonth: 'Last Month',
		lastSevenDays: 'Last 7 Days',
		lastThirtyDays: 'Last 30 Days',
		last365Days: 'Last 365 Days',
	},
	id: {
		lifetime: 'Seumur Hidup',
		yesterday: 'Kemarin',
		today: 'Hari ini',
		thisMonth: 'Bulan ini',
		lastMonth: 'Bulan lalu',
		lastSevenDays: '7 Hari Terakhir',
		lastThirtyDays: '30 Hari Terakhir',
		last365Days: '365 Hari Terakhir',
	},
};

export const emptyCoupon = {
	id: '',
	code: '',
	discount: 0,
	discount_for: '',
};

export const addOnCategories = [
	{
		name: 'Store Design',
		slug: 'store-design',
		subs: [
			{
				name: 'Email Templates',
				slug: 'email-templates',
			},
			{
				name: 'Form Customization',
				slug: 'form-customization',
			},
		],
	},
	{
		name: 'Marketing',
		slug: 'marketing',
		subs: [
			{
				name: 'Advertising',
				slug: 'advertising',
			},
			{
				name: 'Affiliates Programs',
				slug: 'affiliates-programs',
			},
		],
	},
	{
		name: 'Finding Products',
		slug: 'finding-products',
		subs: [],
	},
];

// Order Overview Items
export const orderOverviewItems = {
	submission_count: {
		type: 'normal',
		icon: 'shopping-cart',
		iconType: 'uicons',
		text: 'Total Pesanan',
		info: '',
		stats_enabled: true,
	},
	order_todays: {
		type: 'normal',
		icon: 'shopping-cart',
		iconType: 'uicons',
		text: 'Hari ini',
		info: '',
	},
	order_weeks: {
		type: 'normal',
		icon: 'shopping-cart',
		iconType: 'uicons',
		text: '7 Hari terakhir',
		info: '',
	},
	order_months: {
		type: 'normal',
		icon: 'shopping-cart',
		iconType: 'uicons',
		text: 'Bulan Ini',
		info: '',
	},
	shipping_processed: {
		type: 'normal',
		icon: 'truck-loading',
		iconType: 'uicons',
		text: 'Diproses',
		info: '',
	},
	shipping_pending: {
		type: 'normal',
		icon: 'hourglass-end',
		iconType: 'uicons',
		text: 'Belum Diproses',
		info: '',
		isCanRedirected: true,
		redirectLink: '/admin/orders/pending',
	},
	shipping_delivery: {
		type: 'normal',
		icon: 'rocket-lunch',
		iconType: 'uicons',
		text: 'Dalam Pengiriman',
		info: '',
		isCanRedirected: true,
		redirectLink: '/admin/orders/3pl-pending',
	},
	shipping_completed: {
		type: 'normal',
		icon: 'check',
		iconType: 'uicons',
		text: 'Delivered',
		info: '',
		stats_enabled: true,
	},
	shipping_cancelled: {
		type: 'normal',
		icon: 'cross-circle',
		iconType: 'uicons',
		text: 'Cancelled',
		info: '',
	},
	shipping_return_to_shipper: {
		type: 'normal',
		icon: 'undo',
		iconType: 'uicons',
		text: 'Return',
		info: '',
		stats_enabled: true,
	},
	shipping_refunded: {
		type: 'normal',
		icon: 'hand-holding-usd',
		iconType: 'uicons',
		text: 'Refunded',
		info: '',
	},
	transaction_count: {
		type: 'normal',
		icon: 'credit-card',
		iconType: 'uicons',
		text: 'Total Paid',
		info: '',
	},
	handling_fee: {
		type: 'normal',
		icon: 'credit-card',
		iconType: 'uicons',
		text: 'Handling Fee',
		info: 'Handling Fee for RTS Order',
	},
	shipping_rate: {
		type: 'percentage',
		icon: 'percent',
		iconType: 'feather',
		text: 'Rasio Pengiriman',
		info: '',
	},
	unpaid_count: {
		type: 'normal',
		icon: 'shopping-cart',
		iconType: 'uicons',
		text: 'Unpaid Orders',
		info: 'Processed and Completed Orders that is Unpaid',
	},
	bump_count: {
		type: 'normal',
		icon: 'check-circle',
		iconType: 'feather',
		text: 'Bump Order',
		info: '',
	},
	paid_ratio: {
		type: 'percentage',
		icon: 'percent',
		iconType: 'feather',
		text: 'Paid Ratio',
		info: '',
	},
	coupon_discount_claimed: {
		type: 'price',
		icon: 'coupon',
		text: 'Discount Claimed',
		info: '',
	},
	bump_revenue: {
		type: 'price',
		icon: 'rupiah',
		text: 'Bump Revenue',
		info: '',
	},
	gross_revenue: {
		type: 'price',
		icon: 'rupiah',
		text: 'Gross Revenue',
		info: '',
	},
	net_revenue: {
		type: 'price',
		icon: 'rupiah',
		text: 'Net Revenue',
		info: 'Net Revenue = Gross Revenue - (Shipping Cost - Shipping Cost Discount)',
	},
	shipping_cost: {
		type: 'price',
		icon: 'truck',
		iconType: 'feather',
		text: 'Shipping Cost',
		info: '',
	},
	gross_profit: {
		type: 'price',
		icon: 'rupiah',
		text: 'Gross Profit',
		info: 'Gross Profit = Net Revenue - COGS',
	},
	net_profit: {
		type: 'price',
		icon: 'rupiah',
		text: 'Net Profit',
		info: 'Net Profit = Gross Profit - Expense',
	},
	total_contact: {
		type: 'normal',
		icon: 'users',
		iconType: 'feather',
		text: 'Total Contact',
		info: '',
	},
	total_customer: {
		type: 'normal',
		icon: 'user-check',
		iconType: 'feather',
		text: 'Total Customer',
		info: '',
	},
	average_order: {
		type: 'average_order',
		icon: 'shopping-bag',
		iconType: 'feather',
		text: 'Average Order',
		info: '',
	},
	arpc: {
		type: 'price',
		icon: 'credit-card',
		iconType: 'feather',
		text: 'ARPC/ARPU',
		info: 'Average Revenue Per Customer/User',
	},
	expense_count: {
		type: 'normal',
		icon: '',
		text: 'Expense Items',
		info: '',
	},
	expense: {
		type: 'price',
		icon: 'rupiah',
		text: 'Expenses',
		info: '',
	},
	amount: {
		type: 'price',
		icon: '',
		text: 'Total Expenses',
		info: '',
	},
	automatic_amount: {
		type: 'price',
		icon: '',
		text: 'Total Automatic Expenses',
		info: '',
	},
	cogs: {
		type: 'price',
		icon: 'rupiah',
		text: 'COGS',
		info: 'Cost of Goods Sold',
	},
	unpaid_revenue: {
		type: 'price',
		icon: 'rupiah',
		text: 'Unpaid Revenue',
		info: '',
	},
	quantity: {
		type: 'normal',
		icon: 'shopping-bag',
		iconType: 'feather',
		text: 'Total Quantity Sold',
		info: '',
	},
	shipping_process_return: {
		type: 'normal',
		icon: 'clock',
		iconType: 'feather',
		text: 'On Process Return',
		info: '',
	},
	shipping_return_completed: {
		type: 'normal',
		icon: 'hand-holding-box',
		iconType: 'uicons',
		text: 'Return Completed',
		info: '',
	},
	shipping_return_broken: {
		type: 'normal',
		icon: 'box-open-full',
		iconType: 'uicons',
		text: 'Return Broken',
		info: '',
	},
	leads_order_total: {
		type: 'normal',
		icon: 'shopping-bag',
		iconType: 'feather',
		text: 'Total Leads',
		info: '',
	},
	leads_order_failed: {
		type: 'normal',
		icon: 'shopping-bag',
		iconType: 'feather',
		text: 'Total Failed',
		info: '',
	},
};

// Supplier Pending Order Overview Items
export const supplierPendingOverviewItems = {
	supplier_pending_h1: {
		type: 'normal',
		icon: 'refresh',
		iconType: 'uicons',
		text: 'H+1 Processing',
	},
	supplier_pending_h2: {
		type: 'normal',
		icon: 'refresh',
		iconType: 'uicons',
		text: 'H+2 Processing',
	},
	supplier_pending_h3: {
		type: 'normal',
		icon: 'refresh',
		iconType: 'uicons',
		text: 'H+3 Processing',
	},
	supplier_pending_h4: {
		type: 'normal',
		icon: 'refresh',
		iconType: 'uicons',
		text: '≥ H+4 Processing',
	},
};

// Supplier Pending Order Overview Items
export const deliveryPendingOverviewsItems = {
	third_party_logistic_pending_h1: {
		type: 'normal',
		icon: 'truck-loading',
		iconType: 'uicons',
		text: 'H+1 Manifested',
	},
	third_party_logistic_pending_h2: {
		type: 'normal',
		icon: 'truck-loading',
		iconType: 'uicons',
		text: 'H+2 Manifested',
	},
	third_party_logistic_pending_h3: {
		type: 'normal',
		icon: 'truck-loading',
		iconType: 'uicons',
		text: 'H+3 Manifested',
	},
	third_party_logistic_pending_h4: {
		type: 'normal',
		icon: 'truck-loading',
		iconType: 'uicons',
		text: '≥ H+4 Manifested',
	},
};

// Product Overview Items
export const productOverviewItems = {
	pricing_count: {
		key: 'pricing',
		text: 'Pricing',
	},
	recontent_count: {
		key: 'recontent',
		text: 'Marketing Kit',
	},
	landing_page_count: {
		key: 'landing_page',
		text: 'Landing Page',
	},
	requested_count: {
		key: 'request',
		text: 'Verification',
	},
	updated_count: {
		key: 'updated',
		text: 'Updated',
	},
	active_count: {
		key: 'live',
		text: 'Active',
	},
	out_of_stock_count: {
		key: 'out_of_stock',
		text: 'Out of Stock',
		info: 'Tidak termasuk perhitungan Scoreboard Total',
	},
	rejected_count: {
		key: 'reject',
		text: 'Rejected',
	},
	disabled_count: {
		key: 'disabled',
		text: 'Archived',
	},
	suspended_count: {
		key: 'suspended',
		text: 'Suspended',
	},
	private_count: {
		key: 'private',
		text: 'Private',
		info: 'Tidak termasuk perhitungan Scoreboard Total',
	},
	product_count: {
		key: 'all',
		text: 'Total',
	},
};

export const adminOverviewKeys = [
	'pricing', 'recontent', 'landing_page', 'request', 'updated', 'live',
	'out_of_stock', 'reject', 'disabled', 'suspended', 'all',
];

export const supplierOverviewKeys = adminOverviewKeys;

export const dropshipperOverviewKeys = [
	'live', 'out_of_stock', 'private', 'all',
];

// Default User Data
export const defaultUserData = {
	name: '',
	email: '',
	username: '',
	password: '',
	phone: '',
	package: 'free',
	role: 'owner',
	is_active: true,
	expired_at: 12,
	owner_type: '',
	business_name: '',
	business_address: '',
};

// Zenziva Account Types
export const zenzivaAccountTypes = [
	{ name: 'SMS Reguler', value: 'reguler' },
	{ name: 'SMS Masking', value: 'masking' },
	{ name: 'SMS Center v2.0', value: 'center_v2' },
];

// Dummy AddOns
export const dummyAddOns = [
	{
		_id: 1,
		name: 'Storefront',
		slug: 'storefront',
		icon: 'https://images.ostock.id/3340281531016363943.png',
		tagline: 'Lorem Ipsum dolor sit amet',
		description: 'Lorem Ipsum dolor sit amet',
		partner_id: 1,
		version: '1.0',
		images: [
			'https://apps.shopifycdn.com/listing_images/b1983a5240f536f4369a3e5861489e9c/desktop_screenshot/142c345451095df276d36295682f48e2.png',
			'https://apps.shopifycdn.com/listing_images/b1983a5240f536f4369a3e5861489e9c/desktop_screenshot/59eaed0480dc393f50bcd539de7a73ca.png',
		],
		author: {
			name: 'Ostock',
			url: 'https://ostock.id',
		},
		pricing: [
			{
				_id: 1,
				name: 'Basic',
				price: 500000,
				type: 'otp',
				cycle: 1,
				featured: false,
			},
		],
		rating: {
			average: 5.0,
			total: 2,
		},
	},
	{
		_id: 2,
		name: 'WhatsApp Chat Button',
		slug: 'wa-chat-button',
		icon: 'https://i.ibb.co/S6krHZS/Whats-App-Logo-1.png',
		tagline: 'Lorem Ipsum dolor sit amet',
		description: 'Lorem Ipsum dolor sit amet',
		partner_id: 1,
		version: '1.0',
		author: {
			name: 'Ostock',
			url: 'https://ostock.id',
		},
		pricing: [
			{
				_id: 1,
				name: 'Basic',
				price: 500000,
				type: 'monthly',
				cycle: 6,
				featured: false,
			},
			{
				_id: 2,
				name: 'Premium',
				price: 550000,
				type: 'monthly',
				cycle: 6,
				featured: true,
			},
			{
				_id: 3,
				name: 'Advanced',
				price: 800000,
				type: 'monthly',
				cycle: 6,
				featured: false,
			},
		],
		rating: {
			average: 5.0,
			total: 2,
		},
	},
	{
		_id: 3,
		name: 'LINE Chat Button',
		slug: 'line-chat-button',
		icon: 'https://upload.wikimedia.org/wikipedia/commons/4/41/LINE_logo.svg',
		tagline: 'Lorem Ipsum dolor sit amet',
		description: 'Lorem Ipsum dolor sit amet',
		partner_id: 1,
		version: '1.3',
		author: {
			name: 'Ostock',
			url: 'https://ostock.id',
		},
		pricing: [
			{
				_id: 1,
				name: 'Free',
				price: 0,
				type: 'free',
				cycle: 6,
				featured: false,
			},
		],
		rating: {
			average: 5.0,
			total: 2,
		},
	},
	{
		_id: 4,
		name: 'LINE Chat Button',
		slug: 'line-chat-button',
		icon: 'https://upload.wikimedia.org/wikipedia/commons/4/41/LINE_logo.svg',
		tagline: 'Lorem Ipsum dolor sit amet',
		description: 'Lorem Ipsum dolor sit amet',
		partner_id: 1,
		version: '1.3',
		author: {
			name: 'Ostock',
			url: 'https://ostock.id',
		},
		pricing: [
			{
				_id: 1,
				name: 'Free',
				price: 0,
				type: 'free',
				cycle: 6,
				featured: false,
			},
		],
		rating: {
			average: 5.0,
			total: 2,
		},
	},
];

// Dummy Apps
export const dummyApps = [
	{
		name: 'Ordoro',
		slug: 'ordoro',
		banner:
			'https://apps.shopifycdn.com/listing_images/86b6c03660efc4cd8931f5520f5a68a5/banner/59d59aa695e1a478d39d7f7bd0e3172d.png?height=360&width=640',
		tagline: 'Shipping, Inventory, and Everything In Between',
		partner: {
			name: 'Ordoro',
			slug: 'ordoro',
		},
	},
	{
		name: 'Ordoro',
		slug: 'ordoro',
		banner:
			'https://apps.shopifycdn.com/listing_images/c445f0f56cab256cf45aae9a6ae4566c/banner/04c8c8fe023b0ac301fa8eeceaccc77d.png?height=360&width=640',
		tagline: 'Shipping, Inventory, and Everything In Between',
		partner: {
			name: 'Ordoro',
			slug: 'ordoro',
		},
	},
	{
		name: 'Ordoro',
		slug: 'ordoro',
		banner:
			'https://apps.shopifycdn.com/listing_images/86b6c03660efc4cd8931f5520f5a68a5/banner/59d59aa695e1a478d39d7f7bd0e3172d.png?height=360&width=640',
		tagline: 'Shipping, Inventory, and Everything In Between',
		partner: {
			name: 'Ordoro',
			slug: 'ordoro',
		},
	},
	{
		name: 'Ordoro',
		slug: 'ordoro',
		banner:
			'https://apps.shopifycdn.com/listing_images/c445f0f56cab256cf45aae9a6ae4566c/banner/04c8c8fe023b0ac301fa8eeceaccc77d.png?height=360&width=640',
		tagline: 'Shipping, Inventory, and Everything In Between',
		partner: {
			name: 'Ordoro',
			slug: 'ordoro',
		},
	},
];

export const userSettings = {
	stock: {
		deduction_trigger: 'completed',
		restore_trigger: 'canceled',
		visible: true,
	},
	ui: {
		last_opened_announcements: '2009-01-01 00:00:00',
	},
	// packingSlip: [],
	// blocked_ip: [],
};

export const userIdentity = {
	status: 'requested',
	type: 'ktp',
	image_url: '',
	image_url_full: '',
	reject_note: '',
	number: '',
	uploaded_at: '2022-01-01 00:00:00',
};

// Default Stock Settings
export const defaultStockSettings = {
	deduction_trigger: 'completed',
	restore_trigger: 'canceled',
	visible: true,
};

/**
 * Product Creator Sections
 *
 */
export const productCreatorSections = {
	product: [
		{
			id: 'general',
			name: 'Options',
			icon: 'options',
			iconType: 'custom',
		},
		{
			id: 'storefront',
			name: 'Storefront',
			icon: 'store',
			iconType: 'mi',
		},
		{
			id: 'images',
			name: 'Images',
			icon: 'image',
			iconType: 'custom',
		},
		{
			id: 'pricing',
			name: 'Pricing',
			icon: 'pricing',
			iconType: 'custom',
		},
		{
			id: 'inventory',
			name: 'Inventory',
			icon: 'assignment',
			iconType: 'mi',
		},
		{
			id: 'bump',
			name: 'Bump',
			icon: 'bump',
			iconType: 'custom',
		},
		{
			id: 'shipping',
			name: 'Shipping',
			icon: 'local_shipping',
			iconType: 'mi',
		},
		{
			id: 'payments',
			name: 'Payments',
			icon: 'payment',
			iconType: 'custom',
		},
		{
			id: 'unique-code',
			name: 'Unique Code',
			icon: 'local_atm',
			iconType: 'mi',
		},
		{
			id: 'assignation',
			name: 'Assignment',
			icon: 'people',
			iconType: 'mi',
		},
	],
	checkoutPage: [
		{
			id: 'checkout-page-name',
			name: 'Checkout Page Name',
			icon: '',
			iconType: 'custom',
		},
		{
			id: 'template',
			name: 'Template',
			icon: 'template',
			iconType: 'custom',
		},
		{
			id: 'header',
			name: 'Header',
			icon: 'header',
			iconType: 'custom',
		},
		{
			id: 'images',
			name: 'Images',
			icon: 'image',
			iconType: 'custom',
		},
		{
			id: 'guarantee-seals',
			name: 'Guarantee Seals',
			icon: 'guarantee-seals',
			iconType: 'custom',
		},
		{
			id: 'product-variation',
			name: 'Product Variations',
			icon: 'options',
			iconType: 'custom',
		},
		{
			id: 'fields',
			name: 'Requested Fields',
			icon: 'requested-fields',
			iconType: 'custom',
		},
		{
			id: 'buy-button',
			name: 'Buy Button',
			icon: 'buy-button',
			iconType: 'custom',
		},
		{
			id: 'video',
			name: 'Video',
			icon: 'video',
			iconType: 'custom',
		},
		{
			id: 'description',
			name: 'Description',
			icon: 'description',
			iconType: 'custom',
		},
		{
			id: 'coupon-field',
			name: 'Coupon Field',
			icon: 'coupon-field',
			iconType: 'custom',
		},
		{
			id: 'bullet-points',
			name: 'Bullet Points',
			icon: 'bullet-points',
			iconType: 'custom',
		},
		{
			id: 'order-summary',
			name: "Order's Summary",
			icon: 'receipt',
			iconType: 'mi',
		},
		{
			id: 'testimonials',
			name: 'Testimonials',
			icon: 'testimonials',
			iconType: 'custom',
		},
		{
			id: 'tracking',
			name: 'Tracking',
			icon: 'tracking',
			iconType: 'custom',
		},
	],
	successPage: [
		{
			id: 'success-action',
			name: 'Actions',
			icon: '',
			iconType: 'custom',
		},
		{
			id: 'success-headline',
			name: 'Headline Text',
			icon: 'headline-text',
			iconType: 'custom',
		},
		{
			id: 'success-video',
			name: 'Video',
			icon: 'video',
			iconType: 'custom',
		},
		{
			id: 'success-body',
			name: 'Body Text',
			icon: 'body-text',
			iconType: 'custom',
		},
		{
			id: 'success-tracking',
			name: 'Tracking',
			icon: 'tracking',
			iconType: 'custom',
		},
	],
};

// Team Member Stats
export const membersStats = [
	{
		key: 'paid_ratio',
		isFetching: false,
		values: [],
	},
	{
		key: 'transaction_count',
		isFetching: false,
		values: [],
	},
	{
		key: 'net_revenue',
		isFetching: false,
		values: [],
	},
];

// Stock Update
export const StockUpdate = {
	TYPE_SYNC: 'sync',
	TYPE_INCREASE: 'increase',
	TYPE_DECREASE: 'decrease',
};

// All Order Statuses
export const orderStatuses = [
	'Pending',
	'Processing',
	'Completed',
	'Cancelled',
	'Refunded',
];

export const notifReceiverCapabilities = [
	{
		key: 'range_stock',
		label: 'Range Stock',
		info: 'Notifikasi saat stock produk supplier mencapai kurang dari 200, 100 atau 50',
	},
];

// Payment Options
export const paymentOptions = [
	{ key: 'bank_transfer', label: 'Bank Transfer' },
	{ key: 'cod', label: 'COD', info: 'Cash on Delivery' },
	{
		key: 'instant',
		label: 'E-Payment',
		info: 'Menggunakan Rekber (Payment Gateway)',
	},
];

// Instant Payment Channels
export const paymentChannels = [
	{ key: 'credit_card', label: 'Credit Card' },
	// { key: 'mandiri_clickpay', label: 'Mandiri ClickPay' },
	// { key: 'cimb_clicks', label: 'CIMB Clicks' },
	// { key: 'bca_klikbca', label: 'BCA KlikBCA' },
	// { key: 'bca_klikpay', label: 'BCA KlikPay' },
	// { key: 'bri_epay', label: 'BRI E-Pay' },
	// { key: 'telkomsel_cash', label: 'Telkomsel Cash' },
	{ key: 'echannel', label: 'Mandiri Bill' },
	// { key: 'indosat_dompetku', label: 'Indosat Dompetku' },
	{ key: 'bca_va', label: 'BCA Virtual Account' },
	{ key: 'bni_va', label: 'BNI Virtual Account' },
	{ key: 'permata_va', label: 'Permata Virtual Account' },
	// { key: 'other_va', label: 'Other Virtual Account' },
	// { key: 'kioson', label: 'Kios ON' },
	{
		key: 'gopay',
		label: 'GoPay',
		info: 'Jika dibuka di Desktop akan memunculkan QR Code dan jika dibuka di Mobile, akan membuka aplikasi Gojek',
	},
	{
		key: 'ovo',
		label: 'OVO',
		info: 'Akan memunculkan QR Code di Desktop / Mobile',
	},
	{
		key: 'dana',
		label: 'DANA',
		info: 'Akan memunculkan QR Code di Desktop / Mobile',
	},
	{ key: 'shopeepay', label: 'ShopeePay' },
	// { key: 'indomaret', label: 'Indomaret', disabled: true },
	{ key: 'alfamart', label: 'Alfamart' },
	// { key: 'gci', label: 'GCI' },
	// { key: 'danamon_online', label: 'Danamon Online' },
];

// Billing Plans
export const billingPlans = {
	personal: {
		price: {
			// annually: 790000,
			annually: 590000,
			// biannually: 490000,
			// biannually: 290000,
			biannually: 390000,
		},
		link: 'https://buy.ostock.id/orderonline-personal-6-month',
	},
	professional: {
		price: {
			// annually: 990000,
			annually: 790000,
			// biannually: 690000,
			// biannually: 490000,
			biannually: 590000,
		},
		link: 'https://buy.ostock.id/orderonline-professional-6-month',
	},
	business: {
		price: {
			// annually: 1190000,
			annually: 890000,
			// biannually: 790000,
			// biannually: 590000,
			biannually: 690000,
		},
		link: 'https://buy.ostock.id/orderonline-business-6-month',
	},
	enterprise: {
		price: {
			// annually: 1390000,
			annually: 1490000,
			// biannually: 1190000,
			biannually: 1290000,
		},
		link: 'https://buy.ostock.id/orderonline-enterprise',
	},
};

// Default AutoText
export const defaultAutoText = {
	enabled: false,
	format: 'Halo',
	schedule: {
		type: 'immediately',
		day: 1,
		hour: 1,
	},
};

// Hours
export const hours = [
	{
		value: 0,
		label: '0:00',
	},
	{
		value: 1,
		label: '01:00',
	},
	{
		value: 2,
		label: '02:00',
	},
	{
		value: 3,
		label: '03:00',
	},
	{
		value: 4,
		label: '04:00',
	},
	{
		value: 5,
		label: '05:00',
	},
	{
		value: 6,
		label: '06:00',
	},
	{
		value: 7,
		label: '07:00',
	},
	{
		value: 8,
		label: '08:00',
	},
	{
		value: 9,
		label: '09:00',
	},
	{
		value: 10,
		label: '10:00',
	},
	{
		value: 11,
		label: '11:00',
	},
	{
		value: 12,
		label: '12:00',
	},
	{
		value: 13,
		label: '13:00',
	},
	{
		value: 14,
		label: '14:00',
	},
	{
		value: 15,
		label: '15:00',
	},
	{
		value: 16,
		label: '16:00',
	},
	{
		value: 17,
		label: '17:00',
	},
	{
		value: 18,
		label: '18:00',
	},
	{
		value: 19,
		label: '19:00',
	},
	{
		value: 20,
		label: '20:00',
	},
	{
		value: 21,
		label: '21:00',
	},
	{
		value: 22,
		label: '22:00',
	},
	{
		value: 23,
		label: '23:00',
	},
];

// Contact History Icons
export const contactHistoryIcons = {
	registered: {
		tooltip: 'Registered',
		icon: {
			type: 'awesome',
			name: 'user-plus',
		},
	},
	order_status_changed: {
		tooltip: 'Order Status Changed',
		icon: {
			type: 'material',
			name: 'supervised_user_circle',
		},
	},
	phone_call: {
		tooltip: 'Phone Call',
		icon: {
			type: 'material',
			name: 'phone',
		},
	},
	send_sms_message: {
		tooltip: 'SMS Message',
		icon: {
			type: 'material',
			name: 'sms',
		},
	},
	send_email_message: {
		tooltip: 'Email',
		icon: {
			type: 'material',
			name: 'email',
		},
	},
	note: {
		tooltip: 'Note',
		icon: {
			type: 'material',
			name: 'description',
		},
	},
	reminder: {
		tooltip: 'Schedule',
		icon: {
			type: 'material',
			name: 'date_range',
		},
	},
	create_order: {
		tooltip: 'Create Order',
		icon: {
			type: 'awesome',
			name: 'cart-plus',
		},
	},
	make_payment: {
		tooltip: 'Payment',
		icon: {
			type: 'awesome',
			name: 'dollar-sign',
		},
	},
	make_payment_confirmation: {
		tooltip: 'Payment Confirmation',
		icon: {
			type: 'awesome',
			name: 'money-bill-alt',
		},
	},
	closing: {
		tooltip: 'Success Order',
		icon: {
			type: 'awesome',
			name: 'handshake',
		},
	},
	cancelled: {
		tooltip: 'Cancelled Order',
		icon: {
			type: 'awesome',
			name: 'times',
		},
	},
	send_wa_message: {
		tooltip: 'Whatsapp Message',
		icon: {
			type: 'awesome',
			name: 'brands/whatsapp',
		},
	},
};

export const notifSoundUrl = 'https://cdn.orderonline.id/sounds/notif.mp3';

// Notification Sounds
export const notifSounds = [
	'https://cdn.orderonline.id/sounds/notif.webm',
	'https://cdn.orderonline.id/sounds/notif.mp3',
	'https://cdn.orderonline.id/sounds/notif.ogg',
];

// Coin Sounds
export const coinSounds = [
	'https://cdn.orderonline.id/sounds/coin.webm',
	'https://cdn.orderonline.id/sounds/coin.mp3',
	'https://cdn.orderonline.id/sounds/coin.ogg',
];

// Withdraw Sounds
export const withdrawSounds = [
	'https://cdn.orderonline.id/sounds/withdrawal.webm',
	'https://cdn.orderonline.id/sounds/withdrawal.mp3',
	'https://cdn.orderonline.id/sounds/withdrawal.ogg',
];

// Billing Payment Sounds
export const billingPaymentSounds = [
	'https://cdn.orderonline.id/sounds/billing-payment.webm',
	'https://cdn.orderonline.id/sounds/billing-payment.mp3',
	'https://cdn.orderonline.id/sounds/billing-payment.ogg',
];

// Logistic Sounds
export const logisticSounds = [
	'https://cdn.orderonline.id/sounds/logistic.webm',
	'https://cdn.orderonline.id/sounds/logistic.mp3',
	'https://cdn.orderonline.id/sounds/logistic.ogg',
];

export const barcodeOptions = {
	format: 'CODE128',
	lineColor: '#000',
	width: 15,
	height: 30,
	displayValue: false,
	// flat: true,
};

// Multiple Variations - Quantity Types
export const multipleVariationsQuantityTypes = [
	{ key: 'general', label: 'General' },
	{ key: 'each', label: 'Each Variations' },
];

// Multiple Variations - Select Types
export const multipleVariationsSelectTypes = [
	{ key: 'radio', label: 'Radio' },
	{ key: 'dropdown', label: 'Dropdown' },
];

// Multiple Variations - Row Types
export const multipleVariationsRowTypes = [
	{ key: 'static', label: 'Show All' },
	{ key: 'fluid', label: 'Show Partial' },
];

// Guarantee Seals
export const guaranteeSeals = [
	{
		key: 'satisfaction_id',
		label: '100% Jaminan Kepuasan',
	},
	{
		key: 'money_back_id',
		label: 'Garansi Uang Kembali',
	},
	{
		key: 'encrypted_id',
		label: 'Enkripsi 256-Bit',
	},
	{
		key: 'satisfaction',
		label: '100% Satisfaction Seal',
	},
	{
		key: 'money_back',
		label: 'Money Back Guarantee',
	},
	{
		key: 'encrypted',
		label: '256-Bit Encrypted',
	},
];

// Product Header
export const productHeader = {
	image: '',
	title: {
		enabled: false,
		text: '',
	},
	tagline: {
		enabled: false,
		text: '',
	},
};

// Notification Sound
export const notifSound = new Howl({
	src: notifSounds,
});

// Coin Sound
export const coinSound = new Howl({
	src: coinSounds,
});

// Withdraw Sound
export const withdrawSound = new Howl({
	src: withdrawSounds,
});

// Billing Payment Sound
export const billingPaymentSound = new Howl({
	src: billingPaymentSounds,
});

// Logistic Sound
export const logisticSound = new Howl({
	src: logisticSounds,
});

// Payment Statuses
export const paymentStatuses = [
	{ key: 'all', label: 'All' },
	{ key: 'paid', label: 'Paid' },
	{ key: 'unpaid', label: 'Unpaid' },
];

// COD Providers / Couriers
export const codCouriers = [
	// Custom
	{
		key: 'custom',
		label: 'Custom',
		percentage: 5,
		minimal: 5000,
		maximal: 15000,
		includeShipping: true,
		feeType: 'product',
	},
];

// Payment Methods
export const paymentMethods = {
	bank_transfer: 'Bank Transfer',
	cod: 'COD',
};

// Fee Type Labels
export const feeTypeLabels = {
	product: 'Product',
	product_shipping: 'Product + Shipping',
};

// Dummy User Addons
export const dummyUserAddOns = [
	{
		_id: 1,
		user_id: 1,
		addon_id: 1,
		started_at: '2018-12-12 00:01:01',
		expired_at: '2019-12-12 00:01:01',
		config: {},
		is_active: true,
	},
	{
		_id: 1,
		user_id: 1,
		addon_id: 2,
		started_at: '2018-12-12 00:01:01',
		expired_at: '2019-12-12 00:01:01',
		config: {},
		is_active: false,
	},
];

// Pixel Event Keys
export const pixelEventKeys = [
	'value',
	'currency',
	'content_name',
	'content_category',
];

// Default Pixel Event
export const defaultPixelConfig = {
	value: '{{total_price}}',
	currency: 'IDR',
	content_name: '{{product_name}}',
	content_category: '{{product_category_full}}',
};

// Pixel Values Options
export const pixelValueTokens = [
	'{{total_price}}',
	'{{product_price}}',
	'{{product_name}}',
	'{{product_category_full}}',
];

// Form Modes
export const formModes = [
	{ value: 'all', label: 'Show All' },
	{ value: 'progressive', label: 'Progressive Form' },
];

// Default Follow Up
export const defaultFollowUp = {
	welcome: {
		enabled: true,
		format:
			'Selamat datang di Toko kami {{name}} ☺️\n\nKami sudah terima pesanan anda dengan rincian sebagai berikut,\nProduk: {{product_name}}\nHarga: {{product_price}}\nOngkir: {{shipping_cost}}\nTotal: {{total_price}}\n\n\nDikirim ke:\nNama: {{name}}\nNo HP: {{phone}}\nAlamat: {{address}}\nKota: {{city}}\nKecamatan: {{district}}\n\n\nSilahkan transfer senilai {{total_price}}, ke salah satu rekening dibawah ini:\n{{bank_accounts}}',
		schedule: {
			type: 'immediately',
			day: 0,
			hour: 0,
		},
	},
	order_confirmation_redirect: {
		enabled: false,
		format:
			'Halo, saya sudah melakukan pemesanan {{product_name}}, atas nama {{name}}. Mohon segera diproses ya 🙏🏻',
		schedule: {
			type: 'immediately',
			day: 0,
			hour: 0,
		},
	},
	order_detail: {
		enabled: false,
		format:
			'Pesanan anda:\nProduk: {{product_name}}\nHarga: {{product_price}}\nOngkir: {{shipping_cost}}\nTotal: {{total_price}}\n\n\nDikirim ke:\nNama: {{name}}\nNo HP: {{phone}}\nAlamat: {{address}}\nKota: {{city}}\nKecamatan: {{district}}\n\n\nSilahkan transfer senilai {{total_price}}, ke salah satu rekening dibawah ini:\n{{bank_accounts}}',
		schedule: {
			type: 'immediately',
			day: 0,
			hour: 0,
		},
	},
	follow_up_1: {
		enabled: true,
		format:
			'Hari ini mau transfer jam berapa {{name}}?\nPesanan kami siapkan ya...',
		schedule: {
			type: 'fixed',
			day: 1,
			hour: 16,
		},
	},
	follow_up_2: {
		enabled: true,
		format:
			'Selamat siang {{name}}... Pesanan {{product_name}} sudah siap kirim ya... ☺🙏🏻',
		schedule: {
			type: 'fixed',
			day: 2,
			hour: 12,
		},
	},
	follow_up_3: {
		enabled: true,
		format:
			'Selamat siang, promo untuk pembelian {{product_name}} HARI INI\nDiskon Rp10.000 ya.. ☺🙏🏻',
		schedule: {
			type: 'fixed',
			day: 3,
			hour: 12,
		},
	},
	follow_up_4: {
		enabled: true,
		format:
			'Selamat siang {{name}},\nProduk {{product_name}} laris manis nih, stok kami sisa 5 item saja ya...\nJangan sampe kehabisan ☺🙏🏻',
		schedule: {
			type: 'fixed',
			day: 4,
			hour: 12,
		},
	},
	closing: {
		enabled: true,
		format: 'Terima kasih {{name}} sudah belanja di toko kami 🙏🏻',
		schedule: {
			type: 'immediately',
			day: 0,
			hour: 0,
		},
	},
	up_selling: {
		enabled: false,
		format:
			'Halo, kami lagi ada promo khusus hanya untuk anda {{name}}\n- Produk XYZ, dari Rp180.000 jadi cuma Rp140rb aja ☺\nStok terbatas ya, pesan sekarang sebelum kehabisan...️',
		schedule: {
			type: 'fixed',
			day: 8,
			hour: 9,
		},
	},
	processing: {
		enabled: true,
		format:
			'Pembayaran dari {{name}} untuk pembelian {{product_name}} senilai {{total_price}} telah kami terima, pesanan anda kini kami proses.',
		schedule: {
			type: 'immediately',
			day: 0,
			hour: 0,
		},
	},
	cancelled: {
		enabled: false,
		format: 'Pesanan {{product_name}} anda kini kami batalkan.',
		schedule: {
			type: 'immediately',
			day: 0,
			hour: 0,
		},
	},
};
export const defaultFollowUpSms = {
	welcome: {
		enabled: true,
		format:
			'Halo {{name}}, pesanan {{product_name}} Anda kami proses, segera lakukan pembayaran dengan nominal {{total_price}}',
		schedule: {
			type: 'immediately',
			day: 0,
			hour: 0,
		},
	},
	follow_up_1: {
		enabled: true,
		format:
			'Pesanan {{product_name}} Anda sudah kami siapkan ya, hari ini mau transfer jam berapa {{name}}?',
		schedule: {
			type: 'fixed',
			day: 1,
			hour: 16,
		},
	},
	follow_up_2: {
		enabled: true,
		format:
			'Selamat siang {{name}}, pesanan {{product_name}} Anda sudah siap kirim, silahkan selesaikan pembayaran ya..',
		schedule: {
			type: 'fixed',
			day: 2,
			hour: 12,
		},
	},
	follow_up_3: {
		enabled: true,
		format:
			'Selamat siang {{name}}, promo untuk pembelian {{product_name}} HARI INI diskon Rp10.000 ya..',
		schedule: {
			type: 'fixed',
			day: 3,
			hour: 12,
		},
	},
	follow_up_4: {
		enabled: true,
		format:
			'Selamat siang {{name}}, produk {{product_name}} laris manis nih, stok kami sisa 5 item saja ya, jangan sampe kehabisan..',
		schedule: {
			type: 'fixed',
			day: 4,
			hour: 12,
		},
	},
	closing: {
		enabled: true,
		format: 'Terima kasih {{name}} sudah membeli {{product_name}} :)',
		schedule: {
			type: 'immediately',
			day: 0,
			hour: 0,
		},
	},
	up_selling: {
		enabled: false,
		format:
			'Apa kabar {{name}}? kami lagi ada promo Produk A nih, cuma Rp50.000 aja',
		schedule: {
			type: 'fixed',
			day: 8,
			hour: 12,
		},
	},
	processing: {
		enabled: true,
		format:
			'Pembayaran senilai {{total_price}} untuk pembelian {{product_name}} telah kami terima dan proses',
		schedule: {
			type: 'immediately',
			day: 0,
			hour: 0,
		},
	},
	cancelled: {
		enabled: false,
		format: 'Pesanan {{product_name}} anda kini kami batalkan.',
		schedule: {
			type: 'immediately',
			day: 0,
			hour: 0,
		},
	},
};

// Default COD
export const defaultCod = {
	key: 'custom',
	label: 'Custom',
	percentage: 5,
	minimal: 5000,
	maximal: 15000,
	includeShipping: true,
	feeType: 'product_shipping',
};

// Follow Up Conditions
export const followUpConditions = [
	{
		key: 'bank_transfer',
		value:
			'\n[[BANK_TRANSFER]]\nBank Transfer Only Content\n[[/BANK_TRANSFER]]',
		label: 'Bank Transfer',
	},
	{ key: 'cod', value: '\n[[COD]]\nCOD Only Content\n[[/COD]]', label: 'COD' },
	{
		key: 'instant',
		value: '[[E_PAYMENT]]E-Payment Only Content[[/E_PAYMENT]]',
		label: 'E-Payment',
	},
];

// Follow Up Contents
export const followUpContents = [
	{
		type: 'Variable',
		options: followUpTokens,
	},
	{
		type: 'Conditions',
		options: followUpConditions,
	},
];

export const storefrontAddonId = '5c359d8e215076fe8903d779';

// Shipment Icons
export const shipmentIcons = {
	oexpress: {
		CANCELLED: 'close',
		PICKREQ: 'assignment_turned_in',
		PICK: 'swap_horiz',
		'ENTRI VERIFIED': 'swap_horiz',
		IN: 'home_work',
		'Hold / Pending': 'home_work',
		'Retur Pusat': 'home_work',
		RTA: 'home_work', // Returned
		ANT: 'local_shipping',
		OUT: 'local_shipping',
		NTH: 'remove_circle_outline',
		AU: 'replay',
		DELIVERED: 'check',
		'POD - DELIVERED': 'check',
		LOST: 'close',
		CODB: 'close',
		'POD - UNDELIVERED': 'close',
		BROKE: 'report_problem',
		RTS: 'assignment_returned',
		'RETURN TO SHIPPER': 'assignment_returned',
		'DELIVERY RETURN': 'assignment_returned',
		'SHIPMENT RETURN TO CLIENT': 'assignment_returned',
		'Proof of Delivery - DELIVERED': 'check',
		'Order Verified': 'assignment_turned_in',
		'Pickup Assign to Courier': 'assignment_turned_in',
		'Proof of Delivery - Undelivered': 'assignment_returned',
		'Proof of Delivery - Redelivery': 'close',
		'Proof of Delivery - UNDELIVERED': 'assignment_returned',
	},
	sicepat: {
		CANCELLED: 'close',
		PICKREQ: 'assignment_turned_in',
		PICK: 'swap_horiz',
		// IN: 'archive',
		IN: 'home_work',
		'Hold / Pending': 'home_work',
		'Retur Pusat': 'home_work',
		RTA: 'home_work', // Returned
		ANT: 'local_shipping',
		OUT: 'local_shipping',
		NTH: 'remove_circle_outline',
		'NTH (Not At Home)': 'remove_circle_outline',
		AU: 'replay',
		DELIVERED: 'check',
		LOST: 'close',
		'LOST (Hilang)': 'close',
		HILANG: 'close',
		CODB: 'close',
		BROKE: 'report_problem',
		RTS: 'assignment_returned',
		'(RTS) Return To Shipper': 'assignment_returned',
		'RETURN TO SHIPPER': 'assignment_returned',
		BA: 'map',
		'(BA) Bad Address': 'map',
		MR: 'swap_calls',
		'MR (Misroute)': 'swap_calls',
	},
	jne: {
		CANCELLED: 'close',
		PICKREQ: 'assignment_turned_in',
		PICK: 'swap_horiz',
		IN: 'home_work',
		'Hold / Pending': 'home_work',
		'Retur Pusat': 'home_work',
		RTA: 'home_work', // Returned
		ANT: 'local_shipping',
		OUT: 'local_shipping',
		NTH: 'remove_circle_outline',
		AU: 'replay',
		DELIVERED: 'check',
		LOST: 'close',
		CODB: 'close',
		BROKE: 'report_problem',
		RTS: 'assignment_returned',
		'RETURN TO SHIPPER': 'assignment_returned',
	},
	jnt: {
		100: 'local_shipping', // on delivery
		101: 'home_work', // manifes
		152: 'home_work', // Gudang
		200: 'check', // delivered
		402: 'assignment_returned', // returned
	},
	'J&T': {
		100: 'local_shipping', // on delivery
		101: 'home_work', // manifes
		152: 'home_work', // Gudang
		200: 'check', // delivered
		402: 'assignment_returned', // returned
	},
	sap: {
		CANCELLED: 'close',
		PICKREQ: 'assignment_turned_in',
		PICK: 'swap_horiz',
		'ENTRI VERIFIED': 'swap_horiz',
		IN: 'home_work',
		'Hold / Pending': 'home_work',
		'Retur Pusat': 'home_work',
		RTA: 'home_work', // Returned
		ANT: 'local_shipping',
		OUT: 'local_shipping',
		NTH: 'remove_circle_outline',
		AU: 'replay',
		DELIVERED: 'check',
		'POD - DELIVERED': 'check',
		LOST: 'close',
		CODB: 'close',
		'POD - UNDELIVERED': 'close',
		BROKE: 'report_problem',
		RTS: 'assignment_returned',
		'RETURN TO SHIPPER': 'assignment_returned',
		'DELIVERY RETURN': 'assignment_returned',
		'SHIPMENT RETURN TO CLIENT': 'assignment_returned',
	},
	jx: {
		200: 'local_shipping', // Pick
		10: 'home_work', // Manifest
		110: 'delivery_dining', // On Delivery Courier
		150: 'check', // Delivered
	},
};

// Shipment Status Placeholders
export const shipmentStatusPlaceholders = [
	{
		status: 'PICK',
		notes: 'Paket belum diambil oleh kurir',
		isPlaceholder: true,
	},
	{
		status: 'ANT',
		notes: 'Paket belum diantar oleh kurir',
		isPlaceholder: true,
	},
	{
		status: 'DELIVERED',
		notes: 'Paket belum sampai ke penerima',
		isPlaceholder: true,
	},
];

// Courier Success Codes
export const courierSuccessCodes = {
	jne: ['DELIVERED'],
	sicepat: ['DELIVERED'],
	jnt: [200],
	'J&T': [200],
	sap: ['DELIVERED', 'POD - DELIVERED'],
	jx: [150],
	jdl: [150],
	ninja: ['Completed'],
	idexpress: ['POD scan'],
	paxel: ['PDO'],
	oexpress: ['Proof of Delivery - DELIVERED'],
};

// Courier Pick Codes
export const courierPickCodes = {
	oexpress: ['Order Verified'],
	jne: ['PICK', 'IN'],
	sicepat: ['PICK', 'IN'],
	jnt: [101],
	'J&T': [101],
	sap: ['ENTRI VERIFIED'],
	jx: [200],
	jdl: [200],
	ninja: ['Arrived at Sorting Hub'],
	idexpress: ['Pick up scan'],
	paxel: ['PAPV'],
};

// RTS (Return to Shipper) Codes
export const rtsCodes = [
	'RTS',
	'RETURN TO SHIPPER',
	'(RTS) Return To Shipper',
	402,
	'SHIPMENT RETURN TO CLIENT',
	'Return',
	'Returned to Sender',
	'Return POD Scan', // ID Express
	160,
	'Proof of Delivery - Undelivered', // oexpress
	'Delivery Return', // oexpress
	'Shipment Return to Client', // oexpress
];

// RTS (Return to Shipper) Statuses
export const courierReturnStatuses = {
	sap: [
		'POD - Undelivered',
		'DELIVERY RETURN',
	],
	oexpress: [
		'Proof of Delivery - Undelivered',
		'Delivery Return',
		'Shipment Return to Client',
	],
};

// Delivered Status by Courier
export const allDeliveredStatuses = {
	oexpress: [
		'DELIVERED',
		200,
		'POD - DELIVERED',
		'Proof of Delivery - DELIVERED',
	],
	sap: [
		'DELIVERED',
		200,
		'POD - DELIVERED',
	],
	sicepat: [
		'DELIVERED',
		200,
		'POD - DELIVERED',
		'DLV',
	],
	jne: [
		'DELIVERED',
		200,
		'POD - DELIVERED',
	],
	jnt: [
		'DELIVERED',
		200,
		'POD - DELIVERED',
	],
	'J&T': [
		'DELIVERED',
		200,
		'POD - DELIVERED',
	],
	jx: [
		150,
		'DELIVERED',
	],
	jdl: [
		150,
		'DELIVERED',
		'Order successfully Delivered',
	],
	ninja: [
		'Completed',
		'Delivered',
		'DELIVERED',
		'Berhasil dikirim',
	],
	idexpress: [
		'POD scan',
		'DELIVERED',
		'Paket telah diterima',
		'Paket telah sampai',
	],
	paxel: [
		'PDO',
	],
};

// LOST  Codes
export const lostCodes = ['LOST', 'HILANG', 404];

// Ostock S3 URL
export const s3Url = 'https://orderonline.s3-ap-southeast-1.amazonaws.com';

// Tester IDs
export const testerIds = [
	'5b2dd8569f05aa13cb7b9502', // Septian
	'5d9c0eb99f05aa6da506c734', // Destiyan
	// '5b4451529f05aa39e33d2df2', // SVGGEST
	// '5b7789649f05aa7c0c64a452', // Rifa'i Al Ghazali
	// '5d01eb3d9f05aa05d318e837', // Dede Rakmat
	// '5d73ceb29f05aa40831c59f9', // Akhi Rahman
	// '5b8a8b379f05aa22c13949ba', // NGKS
	// '5d54dcfc9f05aa173a0a5b36', // Ilham
	// '5e2030629f05aa474d237cc3', // Irfan (Irenshop)
];

// Bank Transfer Pickup Tester
export const bankTransferPickupTester = [
	'5b2dd8569f05aa13cb7b9502', // Septian
];

// Support IDs
export const supportIds = [
	'5d9c0efb9f05aa6dfb575b96', // Maulana RF
	'5d9c0eb99f05aa6da506c734', // M Destiyan Putra
	'5eddb3fd9d8e8e5be15bd123', // Sumi
	'60501dcb68e4c0285828d848', // Fajar
	'60501dd424444a345b4d362e', // Krisna
	'607d02185334596ba3013e0c', // Ali
	'607d021d5334596bbc6c9c58', // Iis
];

// Logistic Support IDs
export const logisticSupportIds = [
	'5eddb3fd9d8e8e5be15bd123', // Sumi
];

// Page Options
export const pageOptions = [
	{ key: 'a4', label: 'A4' },
	{ key: 'label', label: 'Shipping Label (100mm x 120mm)' },
];

// Page Formats in Points
export const pageFormats = {
	a4: [595.28, 841.89],
	label: [283.46, 340.15], // 100 mm x 120 mm
	labelSmall: [226.77, 141.73], // 80 mm x 50 mm
	labelLarge: [283.46, 425.197], // 100 mm x 150 mm
};

// Default Success Page / Submit Action data
export const defaultSuccessPage = {
	type: 'success_page',
	data: {
		url: '',
		wa_numbers: [],
		wa_text:
			'Halo, saya sudah melakukan pemesanan {{product_name}}, atas nama {{name}}. Mohon segera diproses ya 🙏🏻',
		body_text: '',
		body_text_cod: '',
		body_text_instant: '',
	},
};

// Courier Discounts from Logistics Vendor (3PL) to Ostock (Ordivo)
export const courierDiscount = {
	oexpress: 35,
	sicepat: 35,
	jne: 35,
	jnt: 35,
	sap: 35,
	ninja: 35,
	idexpress: 35,
	jdl: 35,
};

// Courier Return Fee Discounts
export const courierReturnDiscount = {
	oexpress: 35,
	sicepat: 35,
	jne: 30,
	jnt: 50,
	sap: 35,
	ninja: 35,
	idexpress: 35,
	jdl: 35,
};

// Courier Discounts
export const courierDiscounts = {
	oexpress: [
		{ treshold: 0, discount: courierDiscount.oexpress, cashback: 0 },
	],
	sicepat: [{ treshold: 0, discount: courierDiscount.sicepat, cashback: 0 }],
	jne: [
		{ treshold: 0, discount: courierDiscount.jne, cashback: 0 },
		// { treshold: 500000001, discount: 27, cashback: 0 },
		// { treshold: 1000000001, discount: 30, cashback: 0 },
	],
	jnt: [
		{ treshold: 0, discount: courierDiscount.jnt, cashback: 0 },
		// { treshold: 500000001, discount: 27, cashback: 0 },
		// { treshold: 1000000001, discount: 30, cashback: 0 },
	],
	sap: [
		{ treshold: 0, discount: courierDiscount.sap, cashback: 0 },
		// { treshold: 500000001, discount: 27, cashback: 0 },
		// { treshold: 1000000001, discount: 30, cashback: 0 },
	],
};

// Courier Taxes Percentages
export const courierTaxes = {
	sicepat: {
		cod: 10,
		shipping: 1,
	},
	jnt: {
		cod: 10,
		shipping: 1,
	},
	jne: {
		cod: 10,
		shipping: 1,
	},
	sap: {
		cod: 10,
		shipping: 1,
	},
};

// Enabled Couriers
export const enabledCouriers = ['sicepat', 'sap', 'jne', 'jnt', 'ninja', 'oexpress'];

export const defaultSfMenus = [
	{
		name: 'home',
		title: 'Home',
		slug: '/',
	},
	{
		name: 'products',
		title: 'Products',
		slug: 'products',
	},
	{
		name: 'collections',
		title: 'Collections',
		slug: 'collections',
	},
	{
		name: 'about',
		title: 'About',
		slug: 'about',
	},
	{
		name: 'contact',
		title: 'Contact',
		slug: 'contact',
	},
	{
		name: 'payment_confirmation',
		title: 'Payment Confirmation',
		slug: 'payment-confirmation',
	},
];

// Bank Accounts - Logistic
export const ooBankAccounts = [
	{
		name: 'bca',
		label: 'BCA',
		account_name: 'PT Ordivo Teknologi Indonesia',
		account_number: '2333998009',
	},
];

// Bank Accounts - Business
export const ooBusinessBankAccounts = [
	{
		name: 'bca',
		label: 'BCA',
		account_name: 'PT Ordivo Teknologi Indonesia',
		account_number: '2333338009',
	},
];

// Bank Accounts - Personal
export const ooPersonalBankAccounts = [
	{
		name: 'bca',
		label: 'BCA',
		account_name: 'Rovan Alfarry',
		account_number: '8745130301',
	},
];

// logistics seller action
export const sellerActions = [
	{
		value: 'return',
		label: 'Return',
	},
	{
		value: 'reschedule',
		label: 'Reschedule',
	},
	{
		value: 'complain',
		label: 'Complain',
	},
	{
		value: 'update',
		label: 'Update Data',
	},
	{
		value: 'claim_request',

		label: 'Ajukan Claim',
	},
];

// logistics seller action
export const pickupActions = [
	{
		value: 'pickup_now',
		label: 'Pickup Segera',
	},
	{
		value: 'reschedule_pickup',
		label: 'Reschedule Pickup',
	},
	{
		value: 'pickup_problem',
		label: 'Kendala Pickup',
	},
];

// default section items by themes
export const defaultSfSections = {
	supernova: [
		// slideshow
		{
			id: 'slideshow-1',
			label: 'Slideshow',
			type: 'slideshow',
			is_active: true,
		},
		// seals
		{
			id: 'seals-1',
			label: 'Seals',
			type: 'seals',
			is_active: true,
		},
		// collection
		{
			id: 'collection-1',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 8,
				title: 'Product Collection',
				sort_by: 'transaction_count',
				button_label: 'See All',
			},
		},
		// featured contents
		{
			id: 'featured-1',
			label: 'Featured Contents',
			type: 'featured',
			is_active: true,
		},
	],
	grid: [],
	boutique: [
		// slideshow
		{
			id: 'slideshow-1',
			label: 'Slideshow',
			type: 'slideshow',
			is_active: true,
		},
		// seals
		{
			id: 'seals-1',
			label: 'Seals',
			type: 'seals',
			is_active: true,
		},
		// collection
		{
			id: 'collection-1',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 8,
				title: 'Best Seller',
				sort_by: 'transaction_count',
				button_label: 'View Best Seller',
			},
		},
		// featured contents
		{
			id: 'featured-1',
			label: 'Featured Contents',
			type: 'featured',
			is_active: true,
		},
	],
	breeze: [
		// slideshow
		{
			id: 'slideshow-1',
			label: 'Slideshow',
			type: 'slideshow',
			is_active: true,
		},
		// collection
		{
			id: 'collection-1',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 8,
				title: 'Best Seller',
				sort_by: 'transaction_count',
				button_label: 'View Best Seller',
			},
		},
		// seals
		{
			id: 'seals-1',
			label: 'Seals',
			type: 'seals',
			is_active: true,
		},
		// featured contents
		{
			id: 'featured-1',
			label: 'Featured Contents',
			type: 'featured',
			is_active: true,
		},
	],
	vintage: [
		// slideshow
		{
			id: 'slideshow-1',
			label: 'Slideshow',
			type: 'slideshow',
			is_active: true,
		},
		// seals
		{
			id: 'seals-1',
			label: 'Seals',
			type: 'seals',
			is_active: true,
		},
		// featured contents
		{
			id: 'featured-1',
			label: 'Featured Contents',
			type: 'featured',
			is_active: true,
		},
		// collection
		{
			id: 'collection-1',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 4,
				title: 'New Arrival',
				sort_by: 'created_at',
				button_label: 'View All',
			},
		},
	],
	groovy: [
		// slideshow
		{
			id: 'slideshow-1',
			label: 'Slideshow',
			type: 'slideshow',
			is_active: true,
		},
		// featured contents
		{
			id: 'featured-1',
			label: 'Featured Contents',
			type: 'featured',
			is_active: true,
		},
		// seals
		{
			id: 'seals-1',
			label: 'Seals',
			type: 'seals',
			is_active: true,
		},
		// collection
		{
			id: 'collection-1',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 8,
				title: 'Best Seller',
				sort_by: 'transaction_count',
				button_label: 'View Best Seller',
			},
		},
	],
	beauty: [
		// slideshow
		{
			id: 'slideshow-1',
			label: 'Slideshow',
			type: 'slideshow',
			is_active: true,
		},
		// featured contents
		{
			id: 'featured-1',
			label: 'Featured Contents',
			type: 'featured',
			is_active: true,
		},
		// collection
		{
			id: 'collection-1',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 8,
				title: 'Best Seller',
				sort_by: 'transaction_count',
				button_label: 'View Best Seller',
			},
		},
	],
	aurora: [
		// slideshow
		{
			id: 'slideshow-1',
			label: 'Slideshow',
			type: 'slideshow',
			is_active: true,
		},
		// featured contents
		{
			id: 'featured-1',
			label: 'Featured Contents',
			type: 'featured',
			is_active: true,
		},
		// collection
		{
			id: 'collection-1',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 8,
				title: 'Best Seller',
				sort_by: 'transaction_count',
				button_label: 'View Best Seller',
			},
		},
		// seals
		{
			id: 'seals-1',
			label: 'Seals',
			type: 'seals',
			is_active: true,
		},
	],
	megastore: [
		// slideshow
		{
			id: 'slideshow-1',
			label: 'Slideshow',
			type: 'slideshow',
			is_active: true,
		},
		// seals
		{
			id: 'seals-1',
			label: 'Seals',
			type: 'seals',
			is_active: true,
		},
		// featured contents
		{
			id: 'featured-1',
			label: 'Featured Contents',
			type: 'featured',
			is_active: true,
		},
		// collection
		{
			id: 'collection-1',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 6,
				title: 'Best Seller',
				sort_by: 'transaction_count',
				button_label: 'View Best Seller',
			},
		},
		// collection
		{
			id: 'collection-2',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 6,
				title: 'New Arrival',
				sort_by: 'transaction_count',
				button_label: 'View All',
			},
		},
	],
	monolog: [
		// slideshow
		{
			id: 'slideshow-1',
			label: 'Slideshow',
			type: 'slideshow',
			is_active: true,
		},
		// featured contents
		{
			id: 'featured-1',
			label: 'Featured Contents',
			type: 'featured',
			is_active: true,
		},
		// collection
		{
			id: 'collection-1',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 6,
				title: 'Best Seller',
				sort_by: 'transaction_count',
				button_label: 'View Best Seller',
			},
		},
		// seals
		{
			id: 'seals-1',
			label: 'Seals',
			type: 'seals',
			is_active: true,
		},
	],
	debut: [
		// slideshow
		{
			id: 'slideshow-1',
			label: 'Slideshow',
			type: 'slideshow',
			is_active: true,
		},
		// featured contents
		{
			id: 'featured-1',
			label: 'Featured Contents',
			type: 'featured',
			is_active: true,
		},
		// collection
		{
			id: 'collection-1',
			label: 'Product Collection',
			type: 'collection',
			is_active: true,
			config: {
				limit: 6,
				title: 'Best Seller',
				sort_by: 'transaction_count',
				button_label: 'View Best Seller',
			},
		},
		// seals
		{
			id: 'seals-1',
			label: 'Seals',
			type: 'seals',
			is_active: true,
		},
	],
};

// Valid WA Gateways
export const validWaGateways = ['waboxapp', 'woowa', 'woonotif'];

// Valid SMS Gateways
export const validSmsGateways = ['zenziva'];

// STOREFRONT

export const defaultBodyText =
	'<h3>Terimakasih sudah melakukan pemesanan</h3><br/> \n\n {{custom_fields}}\nUntuk menyelesaikan proses order, silahkan transfer sejumlah \n{{total_price}}\nke salah satu bank berikut ini:\n\n{{bank_accounts}} \n\n <br/>Konfirmasikan pembayaran anda di: {{payment_link}}';

export const defaultBodyCod =
	'<h3>Terimakasih sudah melakukan pemesanan</h3><br/> \n\n Orderan anda kini kami proses, silahkan tunggu kedatangan kurir dan siapkan pembayaran senilai {{total_price}} dan dibayar langsung ke kurir.';

export const storefrontTabs = [
	{ key: 'general', label: 'General', icon: 'settings' },
	{ key: 'ui', label: 'Appearance', icon: 'color_lens' },
	{ key: 'theme', label: 'Theme', icon: 'web' },
	{ key: 'homepage', label: 'Homepage', icon: 'home' },
	{ key: 'sections', label: 'Home Sections', icon: 'line_style' },
	{ key: 'menus', label: 'Menus', icon: 'list' },
	{ key: 'pages', label: 'Pages', icon: 'layers' },
	{ key: 'payment', label: 'Payment', icon: 'payment' },
	{ key: 'assignation', label: 'Assignation', icon: 'people' },
	{ key: 'success', label: 'Success Page', icon: 'check_circle_outline' },
	{ key: 'notifications', label: 'Notifications', icon: 'notifications' },
	{ key: 'autotext', label: 'Auto-Text', icon: 'title' },
	{ key: 'trackings', label: 'Trackings', icon: 'gps_fixed' },
	{ key: 'seo', label: 'SEO', icon: 'analytics' },
	{ key: 'shipping', label: 'Shipping', icon: 'local_shipping' },
];

// Page Builder Container
export const containerSkeleton = {
	type: 'container',
	class: '',
	parentId: '',
	options: {
		type: 'normal',
		padding: '0',
		fontFamily: '',
		fontSize: '',
		textColor: {
			rgb: {
				a: 1,
				b: 0,
				g: 0,
				r: 0,
			},
		},
		backgroundColor: '',
		backgroundImageSrc: '',
		backgroundImageRepeat: 'no-repeat',
		backgroundImageSize: 'cover',
		backgroundImagePosition: 'center center',
		// borderStyle: 'none',
		paddingTop: 1,
		paddingRight: 1,
		paddingBottom: 1,
		paddingLeft: 1,
		paddingUnit: 'em',
		mobilePaddingTop: 1,
		mobilePaddingRight: 1,
		mobilePaddingBottom: 1,
		mobilePaddingLeft: 1,
		mobilePaddingUnit: 'em',
		boxShadowColor: '',
	},
};

// Page Builder Row
export const rowSkeleton = {
	type: 'row',
	class: 'row',
	options: {
		paddingTop: 0,
		paddingRight: 0,
		paddingBottom: 0,
		paddingLeft: 0,
		paddingUnit: 'em',
		mobilePaddingTop: 0,
		mobilePaddingRight: 0,
		mobilePaddingBottom: 0,
		mobilePaddingLeft: 0,
		mobilePaddingUnit: 'em',
		fontFamily: '',
		fontSize: '',
		textColor: '',
		backgroundColor: '',
		backgroundImageSrc: '',
		backgroundImageRepeat: 'no-repeat',
		backgroundImageSize: 'cover',
		backgroundImagePosition: 'center center',
	},
};

// Page Builder Column
export const columnSkeleton = {
	type: 'col',
	class: 'col',
	options: {},
	children: [],
};

export const blockTemplates = [
	// over million
	{
		name: 'Over Million',
		active: true,
		preview:
			'https://library.elementor.com/wp-content/uploads/2018/03/cta_white_3.png',
		template: {
			type: 'container',
			id: 'container_ofxbw',
			class: '',
			parentId: '',
			options: {
				type: 'normal',
				padding: '0',
				fontFamily: '',
				fontSize: '',
				textColor: '',
				backgroundColor: '',
				paddingTop: 2,
				paddingBottom: 2,
				paddingUnit: 'em',
			},
			children: [
				{
					type: 'row',
					class: 'row',
					id: 'row_qgayk',
					key: 'row_qgayk',
					parentId: 'container_ofxbw',
					parentKey: 'container_ofxbw',
					children: [
						{
							type: 'col',
							class: 'col dropzone',
							id: 'col_vyhkq',
							key: 'col_vyhkq',
							parentId: 'container_ofxbw',
							parentKey: 'container_ofxbw',
							options: {},
							children: [
								{
									type: 'heading',
									id: 'heading_pxfcs',
									key: 'heading_pxfcs',
									class: '',
									options: {
										level: 'h2',
										align: 'center',
										fontFamily: 'Lato',
										fontSize: 30,
										fontSizeUnit: 'px',
										textColor: '',
										textBold: false,
										textItalic: false,
										textUnderline: false,
										lineHeight: 1,
										lineHeightUnit: 'em',
										borderColor: '',
										backgroundColor: '',
										backgroundImageSrc: '',
										backgroundImageRepeat: 'no-repeat',
										backgroundImageSize: 'cover',
										backgroundImagePosition: 'center center',
										content: 'Join Over Million People',
									},
									icon: 'title',
									parentId: 'col_vyhkq',
									parentKey: 'col_vyhkq',
								},
								{
									type: 'paragraph',
									id: 'paragraph_qlepu',
									key: 'paragraph_qlepu',
									class: '',
									options: {
										align: 'center',
										fontFamily: 'Lato',
										fontSize: 16,
										fontSizeUnit: 'px',
										textColor: '',
										textBold: false,
										textItalic: false,
										textUnderline: false,
										lineHeight: 1.5,
										lineHeightUnit: 'em',
										borderColor: '',
										backgroundColor: '',
										backgroundImageSrc: '',
										backgroundImageRepeat: 'no-repeat',
										backgroundImageSize: 'cover',
										backgroundImagePosition: 'center center',
										content:
											'<p><span style="text-align: center;display: block">Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed vulputate massa. Fusce ante magna, iaculis ut purus ut, facilisis ultrices nibh. Quisque commodo nunc eget tortor dapibus, et tristique magna convallis. Phasellus egestas nunc eu venenatis vehicula. Phasellus et magna nulla. Proin ante nunc, mollis a lectus ac, volutpat placerat ante. Vestibulum sit amet magna sit amet nunc faucibus mollis. Aliquam vel lacinia purus, id tristique ipsum. Quisque vitae nibh ut libero vulputate ornare quis in risus. Nam sodales justo orci, a bibendum risus tincidunt id. Etiam hendrerit, metus in volutpat tempus.</span></p>',
									},
									icon: 'format_align_left',
									parentId: 'col_vyhkq',
									parentKey: 'col_vyhkq',
								},
								{
									type: 'button',
									id: 'button_ehttt',
									key: 'button_ehttt',
									class: '',
									options: {
										align: 'center',
										level: 'primary',
										style: 'normal',
										backgroundColor: '#2C2C2C',
										fontFamily: 'Lato',
										fontSize: 14,
										fontSizeUnit: 'px',
										textColor: '#ffffff',
										lineHeight: 1.3,
										lineHeightUnit: 'em',
										textBold: false,
										textItalic: false,
										textUnderline: false,
										content: 'Purchase Now',
										paddingTop: 10,
										paddingRight: 20,
										paddingBottom: 10,
										paddingLeft: 20,
										paddingUnit: 'px',
										borderColor: '',
									},
									icon: 'call_to_action',
									parentId: 'col_vyhkq',
									parentKey: 'col_vyhkq',
								},
							],
						},
					],
					options: {
						paddingTop: 10,
						paddingRight: 10,
						paddingBottom: 10,
						paddingLeft: 10,
						paddingUnit: 'px',
						backgroundColor: '',
						backgroundImageSrc: '',
						backgroundImageRepeat: 'no-repeat',
						backgroundImageSize: 'cover',
						backgroundImagePosition: 'center center',
					},
				},
			],
		},
	},

	// company collective
	{
		name: 'Company Collective',
		active: true,
		preview:
			'https://library.elementor.com/wp-content/uploads/2018/03/about_white_10.png',
		template: {
			type: 'container',
			id: 'container_yjqab',
			class: '',
			parentId: '',
			options: {
				type: 'normal',
				fontFamily: '',
				fontSize: '',
				textColor: '',
				backgroundColor: '',
				paddingTop: 30,
				paddingBottom: 30,
				paddingUnit: 'px',
			},
			children: [
				{
					type: 'row',
					class: 'row',
					id: 'row_fmsol',
					key: 'row_fmsol',
					parentId: 'container_yjqab',
					parentKey: 'container_yjqab',
					children: [
						{
							type: 'col',
							class: 'col dropzone',
							id: 'col_ovg',
							key: 'col_ovg',
							parentId: 'container_yjqab',
							parentKey: 'container_yjqab',
							options: {},
							children: [
								{
									type: 'heading',
									id: 'heading_yzjhu',
									key: 'heading_yzjhu',
									class: '',
									options: {
										level: 'h2',
										align: 'center',
										fontFamily: 'Lato',
										fontSize: 20,
										fontSizeUnit: 'px',
										lineHeight: 1,
										lineHeightUnit: 'em',
										textColor: '',
										textBold: false,
										textItalic: false,
										textUnderline: false,
										borderColor: '',
										backgroundColor: '',
										backgroundImageSrc: '',
										backgroundImageRepeat: 'no-repeat',
										backgroundImageSize: 'cover',
										backgroundImagePosition: 'center center',
										content:
											'Our company is a collective of amazing people striving to build delightful products.',
									},
									icon: 'title',
									parentId: 'col_ovg',
									parentKey: 'col_ovg',
								},
								{
									type: 'paragraph',
									id: 'paragraph_jrbxk',
									key: 'paragraph_jrbxk',
									class: '',
									options: {
										align: 'left',
										fontFamily: 'Lato',
										fontSize: '',
										textColor: '',
										textBold: false,
										textItalic: false,
										textUnderline: false,
										lineHeight: 1.5,
										lineHeightUnit: 'em',
										borderColor: '',
										backgroundColor: '',
										backgroundImageSrc: '',
										backgroundImageRepeat: 'no-repeat',
										backgroundImageSize: 'cover',
										backgroundImagePosition: 'center center',
										content:
											'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed vulputate massa. Fusce ante magna, iaculis ut purus ut, facilisis ultrices nibh. Quisque commodo nunc eget tortor dapibus, et tristique magna convallis. Phasellus egestas nunc eu venenatis vehicula. Phasellus et magna nulla. Proin ante nunc, mollis a lectus ac, volutpat placerat ante. Vestibulum sit amet magna sit amet nunc faucibus mollis. Aliquam vel lacinia purus, id tristique ipsum. Quisque vitae nibh ut libero vulputate ornare quis in risus. Nam sodales justo orci, a bibendum risus tincidunt id. Etiam hendrerit, metus in volutpat tempus.',
									},
									icon: 'format_align_left',
									parentId: 'col_ovg',
									parentKey: 'col_ovg',
								},
								{
									type: 'link',
									id: 'link_cwmgd',
									key: 'link_cwmgd',
									class: '',
									options: {
										link: 'http://www.example.com',
										fontFamily: 'Lato',
										fontSize: '',
										textColor: '#1D1D1D',
										textBold: false,
										textItalic: false,
										textUnderline: false,
										lineHeight: 1.3,
										lineHeightUnit: 'em',
										align: 'left',
										borderColor: '',
										backgroundColor: '',
										backgroundImageSrc: '',
										backgroundImageRepeat: 'no-repeat',
										backgroundImageSize: 'cover',
										backgroundImagePosition: 'center center',
										content: 'Purchase Now',
									},
									icon: 'link',
									parentId: 'col_ovg',
									parentKey: 'col_ovg',
								},
							],
						},
					],
					options: {
						paddingTop: 10,
						paddingRight: 10,
						paddingBottom: 10,
						paddingLeft: 10,
						paddingUnit: 'px',
						backgroundColor: '',
						backgroundImageSrc: '',
						backgroundImageRepeat: 'no-repeat',
						backgroundImageSize: 'cover',
						backgroundImagePosition: 'center center',
					},
				},
			],
		},
	},
];

export const generateHtmlCode = (title = '', body = '', gtmID = '') => {
	let gtmCode = '';

	if (gtmID && gtmID !== '') {
		gtmCode = `
			<!-- Google Tag Manager -->
			<script>
			(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
			new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
			j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
			'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','${gtmID}');
			</script>
			<!-- End Google Tag Manager -->`;
	}

	const htmlCode = `<!DOCTYPE html>
		<head>
			<title>Ostock - ${title}</title>
			<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" crossorigin="anonymous">
		</head>
		<html lang="en">
			<body>
				${body}

				${gtmCode}
			</body>
		</html>`;

	return htmlCode;
};

// Status Change Options
export const statusChangeOptions = [
	{
		value: 'processing',
		label: 'Processing',
	},
	{
		value: 'completed',
		label: 'Completed',
	},
	{
		value: 'initial',
		label: "Don't Change",
	},
];

// Status Delivered Options
export const statusDeliveredOptions = [
	{
		value: 'completed',
		label: 'Completed',
	},
	{
		value: 'initial',
		label: "Don't Change",
	},
];

// PT Ordivo Teknologi Indonesia
export const ORDIVO_ACCOUNT_NUMBER_BCA = '2333998009';

// Default Funnel Steps
export const defaultSteps = [
	{
		id: 1,
		type: 'page', // page, button
		value: '',
	},
];

// Placeholder Image
export const defaultBannerImage = 'https://place-hold.it/1600x900';

// export const fileTypes = {
// 	'image': [],
// };

// Chart Data Template
export const visitorChartTemplate = {
	chartId: 'visitor',
	labels: [],
	datasets: [
		{
			label: 'Visitor',
			borderColor: 'rgba(0, 152, 218, 0.7)',
			pointBackgroundColor: '#FFFFFF',
			borderWidth: 1,
			pointBorderColor: '#666666',
			backgroundColor: 'rgba(0, 152, 218, 0.7)',
			data: [],
		},
	],
};

// E-Payment Channels
export const PAYMENT_CHANNELS = {
	CREDIT_CARD: 'credit_card',
	BCA_VA: 'bca_va',
	BNI_VA: 'bni_va',
	PERMATA_VA: 'permata_va',
	OTHER_VA: 'other_va',
	GOPAY: 'gopay',
	OVO: 'ovo',
	DANA: 'dana',
	SHOPEEPAY: 'shopeepay',
	INDOMARET: 'indomaret',
	ALFAMART: 'alfamart',
	GCI: 'gci',
	ECHANNEL: 'echannel', // Mandiri Bill
};

// Page Builder Section Name
export const sectionNames = [
	// 'Header', 'Product', 'Blog', 'Featured', 'Price', 'Footer', 'Action',
	'Header',
	'Hero',
	'Problem',
	'Solution',
	'Feature',
	'Product',
	'Gallery',
	'Testimonial',
	'Pricing',
	'Call to Action',
	'FAQ',
	'Footer',
];

// Default Chart Colors
export const chartColors = [
	'rgb(255, 99, 132)', // red
	'rgb(255, 159, 64)', // orange
	// 'rgb(255, 205, 86)', // yellow
	'rgb(187, 227, 109)', // light green
	'rgb(75, 192, 192)', // green
	'rgb(54, 162, 235)', // blue
	'rgb(153, 102, 255)', // purple
	'rgb(201, 203, 207)', // grey
	'rgb(255, 99, 132)', // red
	'rgb(255, 159, 64)', // orange
	// 'rgb(255, 205, 86)', // yellow
	'rgb(187, 227, 109)', // light green
	'rgb(75, 192, 192)', // green
	'rgb(54, 162, 235)', // blue
	'rgb(153, 102, 255)', // purple
	'rgb(201, 203, 207)', // grey
	'rgb(255, 99, 132)', // red
	'rgb(255, 159, 64)', // orange
	// 'rgb(255, 205, 86)', // yellow
	'rgb(187, 227, 109)', // light green
	'rgb(75, 192, 192)', // green
	'rgb(54, 162, 235)', // blue
	'rgb(153, 102, 255)', // purple
	'rgb(201, 203, 207)', // grey
];

// Default Chart Colors
export const chartColorsAlpha = [
	{
		bg: 'rgba(0, 152, 218, 0.7)',
		border: 'rgba(0, 152, 218, 0.8)',
	},
	// Red
	{
		bg: 'rgba(255, 99, 132, 0.7)',
		border: 'rgba(255, 99, 132, 0.8)',
	},
	// Orange
	{
		bg: 'rgba(255, 159, 64, 0.7)',
		border: 'rgba(255, 159, 64, 0.8)',
	},
	// Yellow
	{
		bg: 'rgba(255, 205, 86, 0.7)',
		border: 'rgba(255, 205, 86, 0.8)',
	},
	// Green
	{
		bg: 'rgba(75, 192, 192, 0.7)',
		border: 'rgba(75, 192, 192, 0.8)',
	},
	// Blue
	{
		bg: 'rgba(54, 162, 235, 0.7)',
		border: 'rgba(54, 162, 235, 0.8)',
	},
	// Purple
	{
		bg: 'rgba(153, 102, 255, 0.7)',
		border: 'rgba(153, 102, 255, 0.8)',
	},
	// Grey
	{
		bg: 'rgba(201, 203, 207, 0.7)',
		border: 'rgba(201, 203, 207, 0.8)',
	},
];

// OLD PLANS
export const oldPlans = [
	'free',
	'personal',
	'professional',
	'business',
	'enterprise',
];

// NEW PLANS
export const newPlans = ['personal_2', 'business_2', 'enterprise_2'];

export const PAYMENT_METHOD_INSTANT = 'instant';
export const PAYMENT_METHOD_BANK_TRANSFER = 'bank_transfer';
export const PAYMENT_METHOD_COD = 'cod';

// User - Features
export const userFeatures = [
	// { value: 'shipment_bank_transfer', label: 'Pickup - Bank Transfer' },
	// { value: 'shipment_cod', label: 'Pickup - COD' },
	// { value: 'reseller', label: 'Reseller' },
	// { value: 'filter_smart_couriers', label: 'Filter Smart Couriers' },
	// { value: 'withdraw_disabled', label: 'Withdraw - Disabled' },
	// { value: 'smart_pickup', label: 'Smart Pickup' },
	// { value: 'smart_shipping', label: 'Smart Shipping' },
	{ value: 'shipping_label_seller_phone', label: 'Shipping Label - Show Seller Phone' },
	{ value: 'product_multiwarehouse', label: 'Product - Multiwarehouse' },
	{ value: 'product_variation_toggle', label: 'Product - Variation Toggle' },
	{ value: 'private_order', label: 'Wholesale Order' },
];

export const featureOption = {
	admin: [],
	supplier: [
		{ value: 'shipping_label_seller_phone', label: 'Shipping Label - Show Seller Phone' },
		{ value: 'product_multiwarehouse', label: 'Product - Multiwarehouse' },
		{ value: 'product_variation_toggle', label: 'Product - Variation Toggle' },
		{ value: 'private_order', label: 'Wholesale Order' },
	],
	sellers: [
		{ value: 'private_order', label: 'Wholesale Order' },
	],
};

// tickets
export const ticketsType = [
	{
		value: 'general',
		label: 'General',
	},
	{
		value: 'logistic',
		label: 'Logistic',
	},
];

export const ticketsTopic = [
	{
		type: 'general',
		value: 'checkout',
		label: 'Checkout Page',
	},
	{
		type: 'general',
		value: 'other',
		label: 'Other',
	},
	{
		type: 'logistic',
		value: 'stuck',
		label: 'Shipment stuck',
	},
	{
		type: 'logistic',
		value: 'pickup',
		label: 'Shipment pickup',
	},
];

export const LOGISTIC_STATUS_HOLD = 'hold';
export const LOGISTIC_STATUS_REJECT = 'reject';
export const LOGISTIC_STATUS_LOST = 'lost';
export const LOGISTIC_STATUS_BROKEN = 'broken';
export const LOGISTIC_STATUS_STUCK = 'stuck';
export const LOGISTIC_STATUS_RETURN = 'return';
export const LOGISTIC_STATUS_UNPICK = 'unpick';

export const CLAIM_TYPES = [
	{
		value: 'broken',
		label: 'Broken',
	},
	{
		value: 'lost',
		label: 'Lost',
	},
	{
		value: 'uncovered',
		label: 'Uncovered',
	},
	{
		value: 'over_sla',
		label: 'Over SLA',
	},
	{
		value: 'free_shipping',
		label: 'Free Shipping',
	},
];

// Courier COD Fee Percentages
export const courierCodFee = [
	{
		percentage: 0.03,
		type: 'product',
		name: 'sicepat',
	},
	{
		percentage: 0.03,
		type: 'total',
		name: 'jnt',
	},
	{
		percentage: 0.03,
		type: 'total',
		name: 'jne',
	},
	{
		percentage: 0.03,
		type: 'total',
		name: 'sap',
	},
];

// static categories
export const dropshipCategories = [
	{
		name: 'Semua Kategori',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/semua_kategori.svg',
		slug: 'all',
	},
	{
		name: 'Fashion Pria',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/fashion_pria.svg',
		slug: 'fashion-pria',
	},
	{
		name: 'Fashion Wanita',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/fashion_wanita.svg',
		slug: 'fashion-wanita',
	},
	{
		name: 'Fashion Anak',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/fashion_anak.svg',
		slug: 'fashion-anak',
	},
	{
		name: 'Kecantikan',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/kecantikan.svg',
		slug: 'kecantikan',
	},
	{
		name: 'Kesehatan',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/kesehatan.svg',
		slug: 'kesehatan',
	},
	{
		name: 'Ibu & Bayi',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/ibu_n_bayi.svg',
		slug: 'ibu-bayi',
	},
	{
		name: 'Rumah Tangga',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/rumah_tangga.svg',
		slug: 'rumah-tangga',
	},
	{
		name: 'Makanan & Minuman',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/makanan_n_minuman.svg',
		slug: 'makanan-minuman',
	},
	{
		name: 'Otomotif',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/otomotif.svg',
		slug: 'otomotif',
	},
	{
		name: 'Olahraga',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/olahraga.svg',
		slug: 'olahraga',
	},
	{
		name: 'Mainan & Hobi',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/mainan_n_hobi.svg',
		slug: 'mainan-hobi',
	},
	{
		name: 'Komputer & Aksesoris',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/komputer_n_aksesoris.svg',
		slug: 'komputer-aksesoris',
	},
	{
		name: 'Handphone & Tablet',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/handphone_n_tablet.svg',
		slug: 'handphone-tablet',
	},
	{
		name: 'Gaming',
		image_url: 'https://cdn.ostock.id/icons/ostock-category/gaming.svg',
		slug: 'gaming',
	},
	// {
	// 	name: 'Lainnya',
	// 	image_url: 'https://cdn.ostock.id/icons/ostock-category/produk_lainnya.svg',
	// 	slug: 'uncategorized',
	// },
];

export const homepageFilterprices = [
	{
		id: 1,
		name: '< Rp50.000',
		value: '<50000',
	},
	{
		id: 2,
		name: 'Rp50.000 - Rp100.000',
		value: '50000-100000',
	},
	{
		id: 3,
		name: 'Rp100.000 - Rp300.000',
		value: '100000-300000',
	},
	{
		id: 4,
		name: 'Rp300.000 - Rp500.000',
		value: '300000-500000',
	},
	{
		id: 5,
		name: '> Rp500.000',
		value: '>500000',
	},
];

export const homepageFeaturedLocations = [
	{
		id: 1,
		name: 'Kota Jakarta Pusat',
		value: 152,
	},
	{
		id: 2,
		name: 'Kota Bandung',
		value: 23,
	},
	{
		id: 3,
		name: 'Kota Bogor',
		value: 78,
	},
	{
		id: 4,
		name: 'Kota Depok',
		value: 115,
	},
];

export const paginationMaxVisibleButtons = 7;

export const footerSocialIcons = [
	{
		name: 'linkedin',
		icon: 'bi-linkedin',
		link: 'https://www.linkedin.com',
	},
	{
		name: 'facebook',
		icon: 'bi-facebook',
		link: 'https://www.facebook.com',
	},
	{
		name: 'instagram',
		icon: 'bi-instagram',
		link: 'https://www.instagram.com',
	},
	{
		name: 'twitter',
		icon: 'bi-twitter',
		link: 'https://twitter.com',
	},
	{
		name: 'tiktok',
		icon: 'bi-tiktok',
		link: 'https://www.tiktok.com',
	},
];

export const sectionConfigTemplate = {
	section_image_url: '',
	background_color: {
		enabled: false,
		color: '',
	},
	text_color: {
		enabled: false,
		color: '',
	},
};

// static homepage sections

export const homepageSections = [
	{
		id: 1,
		name: 'Top Product',
		slug: 'top-product',
		type: 'Featured',
		meta: {
			title: 'Top Produk',
			icon: 'bi-tags',
		},
		description: 'Show 6 top product based on sales',
		canMultiple: true,
		config: [
			sectionConfigTemplate,
		],
	},
	{
		id: 2,
		name: 'Top Category',
		slug: 'top-category',
		type: 'TopCategory',
		meta: {
			title: 'Top Kategori',
			icon: 'bi-award',
		},
		description: 'Show 6 top category based on sales',
		canMultiple: true,
		config: [],
	},
	{
		id: 3,
		name: 'Recomended Product',
		slug: 'recomended-product',
		type: 'Featured',
		meta: {
			title: 'Produk Rekomendasi',
			icon: 'bi-bag-check',
		},
		description: 'Show 12 recomended product',
		canMultiple: true,
		config: [
			{
				product: {},
			},
			{
				product: {},
			},
			{
				product: {},
			},
			{
				product: {},
			},
			{
				product: {},
			},
			{
				product: {},
			},
			{
				product: {},
			},
			{
				product: {},
			},
			{
				product: {},
			},
			{
				product: {},
			},
			{
				product: {},
			},
			{
				product: {},
			},
			sectionConfigTemplate,
		],
	},
	{
		id: 4,
		name: 'Selling Point',
		slug: 'selling-point',
		type: 'SellingPoint',
		meta: {},
		description: 'Show 5 selling point',
		canMultiple: true,
		config: [
			{
				title: '',
				image_url: '',
				url_to: '',
			},
			{
				title: '',
				image_url: '',
				url_to: '',
			},
			{
				title: '',
				image_url: '',
				url_to: '',
			},
			{
				title: '',
				image_url: '',
				url_to: '',
			},
			{
				title: '',
				image_url: '',
				url_to: '',
			},
		],
	},
	{
		id: 5,
		name: 'Single Banner',
		slug: 'single-banner',
		type: 'SingleBanner',
		meta: {},
		description: 'Show 1 image banner',
		canMultiple: true,
		config: {
			title: '',
			url: '',
			image_url: '',
			mobile_image_url: '',
		},
	},
	{
		id: 6,
		name: 'Selling Point With Text',
		slug: 'selling-point-with-text',
		type: 'SellingPointWithText',
		meta: {},
		description: 'Show 3 selling point with description',
		canMultiple: true,
		config: [
			{
				title: '',
				description: '',
				image_url: '',
			},
			{
				title: '',
				description: '',
				image_url: '',
			},
			{
				title: '',
				description: '',
				image_url: '',
			},
		],
	},
	{
		id: 7,
		name: 'Product Category',
		slug: 'product-category',
		type: 'ProductCategory',
		meta: {
			title: 'Kategori Produk',
			icon: 'bi-bag-check',
		},
		description: 'Show category and 12 product list',
		canMultiple: false,
		config: [
			sectionConfigTemplate,
		],
	},
	{
		id: 8,
		name: '2 Column Banner',
		slug: 'two-column-banner',
		type: 'TwoColumnBanner',
		meta: {},
		description: 'Show 2 image banner',
		canMultiple: true,
		config: {
			title: '',
			first_url: '',
			first_image_url: '',
			first_mobile_image_url: '',
			second_url: '',
			second_image_url: '',
			second_mobile_image_url: '',
		},
	},
	{
		id: 9,
		name: 'Best Margin',
		slug: 'best-margin',
		type: 'Featured',
		meta: {
			title: 'Best Margin',
			icon: 'bi-tags',
		},
		description: 'Show 6 best margin products',
		canMultiple: true,
		config: [
			sectionConfigTemplate,
		],
	},
	{
		id: 10,
		name: 'New Product',
		slug: 'new-product',
		type: 'Featured',
		meta: {
			title: 'New Product',
			icon: 'bi-tags',
		},
		description: 'Show 6 new products',
		canMultiple: true,
		config: [
			sectionConfigTemplate,
		],
	},
	{
		id: 11,
		name: '4 Column Banner',
		slug: 'four-column-banner',
		type: 'FourColumnBanner',
		meta: {},
		description: 'Show 4 image banner',
		canMultiple: true,
		config: {
			title: '',
			first_url: '',
			first_image_url: '',
			first_mobile_image_url: '',
			second_url: '',
			second_image_url: '',
			second_mobile_image_url: '',
			third_url: '',
			third_image_url: '',
			third_mobile_image_url: '',
			fourth_url: '',
			fourth_image_url: '',
			fourth_mobile_image_url: '',
		},
	},
];

export const targetOptions = [
	{
		label: '< 10 Juta',
		value: '<10000000',
	},
	{
		label: '10 - 50 Juta',
		value: '10000000-50000000',
	},
	{
		label: '50 - 100 Juta',
		value: '50000000-100000000',
	},
	{
		label: '> 100 Juta',
		value: '>100000000',
	},
];

export const statusOptions = [
	{
		label: 'Review',
		value: 'review',
		color: 'warning',
	},
	{
		label: 'Approve',
		value: 'approve',
		color: 'success',
	},
	{
		label: 'Reject',
		value: 'reject',
		color: 'danger',
	},
];

export const fraudStatusOptions = [
	{
		label: 'Not Fraud',
		value: 'not_fraud',
		color: 'secondary',
	},
	{
		label: 'Potential Fraud',
		value: 'potential_fraud',
		color: 'warning',
	},
	{
		label: 'Fraud',
		value: 'fraud',
		color: 'danger',
	},
];

export const fraudTypeOptions = [
	{
		label: 'Resi melewati batas minimum 50',
		value: 'receipt_number_50',
	},
];

export const ostockBankAccount = {
	name: 'bca',
	label: 'BCA',
	account_name: 'OSTOCK PROFITAMA INDONESIA',
	account_number: '2336660600',
};

export const defaultLandingPage = {
	type: {
		value: 'orderonline',
		label: 'Order Online',
		disabled: false,
	},
	url: '',
	previews: [],
};

export const defaultPageTypes = [
	{
		value: 'orderonline',
		label: 'Order Online',
		disabled: false,
	},
	{
		value: 'berdu',
		label: 'Berdu',
		disabled: false,
	},
	// {
	// 	value: 'woocommerce',
	// 	label: 'WooCommerce',
	// 	disabled: true,
	// },
	{
		value: 'wordpress',
		label: 'Wordpress',
		disabled: false,
	},
];

export const sourceOptions = [
	{
		question: 'How did you find out about Ostock',
		label: 'Media sosial (seperti Facebook, Twitter, Instagram)',
		value: 'social_media',
	},
	{
		question: 'How did you find out about Ostock',
		label: 'Situs web berita atau blog',
		value: 'web',
	},
	{
		question: 'How did you find out about Ostock',
		label: 'Forum online atau komunitas',
		value: 'community',
	},
	{
		question: 'How did you find out about Ostock',
		label: 'Melalui email',
		value: 'email',
	},
	{
		question: 'How did you find out about Ostock',
		label: 'Teman',
		value: 'friend',
	},
	{
		question: 'How did you find out about Ostock',
		label: 'Lainnya (Mohon jelaskan)',
		value: 'others',
	},
];

export const salesRangeOptions = [
	{
		label: '0-100',
		value: '0-100',
	},
	{
		label: '101-500',
		value: '101-500',
	},
	{
		label: '501-1000',
		value: '501-1000',
	},
	{
		label: 'Lebih dari 1000',
		value: '>1000',
	},
];

export const salesPeriodOptions = [
	{
		label: 'Per Hari',
		value: 'day',
	},
	{
		label: 'Per Bulan',
		value: 'month',
	},
];

export const sourceTypeOptions = [
	{
		value: 'all',
		label: 'All',
	},
	{
		value: 'ostock',
		label: 'Ostock',
	},
];

export const adminRolesOptions = [
	{
		value: 'admin',
		label: 'Admin',
	},
	{
		value: 'superadmin',
		label: 'Super Admin',
	},
	{
		value: 'finance',
		label: 'Finance',
	},
	{
		value: 'admin_order',
		label: 'Admin Order',
	},
	{
		value: 'admin_content',
		label: 'Admin Content',
	},
];

export const metaPixelItems = ['register'];

export const defaultProductImageOstock = 'https://cdn.ostock.id/img/default-product.png';

export const productErrorMessages = {
	product: {
		errors: {},
		errorMessages: {
			name: 'Product Name cannot be empty & Max 100 characters',
			slug: 'Checkout page URL is not available',
			code: 'Product Code cannot be empty',
			price: 'Price is not valid',
			variations: 'Product Variations is not valid',
			weight: 'Product Weight cannot be empty (min 1g)',
			bump_name: 'Bump Name cannot be empty',
			bump_price: 'Bump Price is not valid',
			shipping_couriers: 'Shipping Couriers must be selected at least 1. <a href="#shipping" class="error-fix-link" data-id="shipping">Fix Error</a>',
			shipping_province: 'Shipping Province cannot be empty. <a href="#shipping" class="error-fix-link" data-id="shipping">Fix Error</a>',
			shipping_city: 'Shipping City cannot be empty. <a href="#shipping" class="error-fix-link" data-id="shipping">Fix Error</a>',
			shipping_subdistrict: 'Shipping Subdistrict cannot be empty. <a href="#shipping" class="error-fix-link" data-id="shipping">Fix Error</a>',
			payment: 'Payment Method must be selected at least 1 . <a href="#payments" class="error-fix-link" data-id="payments">Fix Error</a>',
			assignation: 'Assign team member percentage must be 100%. <a href="#assignation" class="error-fix-link" data-id="assignation">Fix Error</a>',
			wholesale: 'Wholesale Price still have an error, please fix the error. <a href="#pricing" class="error-fix-link" data-id="pricing">Fix Error</a>',
			price_instant: 'To use E-Payment, price need to be equal or greater than 1.000. <a href="#pricing" class="error-fix-link" data-id="pricing">Fix Error</a>',
			reseller: 'Reseller commission value cannot be greater than the product price. <a href="#pricing" class="error-fix-link" data-id="reseller">Fix Error</a>',
			videos: 'Youtube video url is invalid',
			category: 'Main Category is required',
			stock_simple: 'Stock should be more than 0',
			stock_variable: 'Stock should be more than 0 for each variants',
			supplier: 'Supplier cannot be empty',
			warehouse: 'Warehouse must be selected at least one. <a href="#inventory" class="error-fix-link" data-id="inventory">Fix Error</a>',
			variationEnabled: 'At least one variation must be enabled',
			phone_number_pickup: 'Invalid phone number format',
			phone_number_pickup_required: 'Phone number cannot be empty',
			phone_number_support: 'Invalid phone number format',
		},
	},
	checkoutPage: {
		errors: {},
		errorMessages: {
			formName: 'Checkout Page Name cannot be empty',
			title: 'Title cannot be empty',
			tagline: 'Tagline cannot be empty',
			buy_button: 'Buy Button cannot be empty',
		},
	},
	successPage: {
		errors: {},
		errorMessages: {
			title: 'Title cannot be empty',
			headline: 'Headline cannot be empty',
			url: 'URL cannot be empty and must be a valid url',
			wa: 'WhatsApp Number cannot be empty and must be a valid number',
			cs_wa: 'You must assign Customer Service to this product.',
		},
	},
	done: {
		errors: {},
	},
};

export const defaultOutsourceCommision = {
	type: 'percentage',
	value: 5,
};

export const defaultSalesField = {
	name: '',
	nickname: '',
	email: '',
	phone: '',
};

export const defaultOptionStatusTicket = [
	{ key: 'open', label: 'Open' },
	{ key: 'in_progress', label: 'In Progress' },
	{ key: 'resolved', label: 'Resolved' },
	{ key: 'closed', label: 'Closed' },
];

// Allowed Courier Services
export const allowedCourierServices = [
	'OKE', // JNE - Economical
	'REG', // JNE, Sicepat
	'CTC', // JNE - Regular
	'EZ', // J&T
	'EZGG',
	'UDRREG', // SAP
	'STANDARD', // Ninja
	'GOKIL', // SiCepat Cargo
	'00', // ID Express
	'JTR', // JNE Trucking
	'SIUNT', // SiCepat - Economical
	'SERBU', // OExpress - Regular /Serbu
	'HORE', // OExpress - HORE
	'03', // ID Express Lite - Economical
];

// Couriers Code saved on Orders
export const COURIERS_CODE = {
	OEXPRESS: 'oexpress',
	JNE: 'jne',
	SICEPAT: 'sicepat',
	SAP: 'sap',
	JNT: 'J&T',
	JNT_2: 'jnt',
	NINJA: 'ninja',
	JX: 'jx',
	IDEXPRESS: 'idexpress',
	JDL: 'jdl',
	PAXEL: 'paxel',
	INDAH_EXPRESS: 'indahexpress',
};

export const IDEXPRESS_SERVICES = [
	{
		code: '00',
		label: 'STANDARD',
	},
	{
		code: '03',
		label: 'IDLITE',
	},
];

export const OTP_TYPE = [
	{
		label: 'Phone Verification',
		key: 'phone_verification',
	},
	{
		label: 'Update Email',
		key: 'update_email',
	},
	{
		label: 'Update Phone Number',
		key: 'update_phone_number',
	},
	{
		label: 'Add Bank Account',
		key: 'add_bank_account',
	},
	{
		label: 'Withdrawal',
		key: 'withdrawal',
	},
];

export const ASK_STOCK_PHONE_NUMBER = '6281222001512';
